/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Country code scalar */
  CountryCodeScalar: { input: any; output: any; }
  DateFormat: { input: any; output: any; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
  GraphQLObject: { input: any; output: any; }
  MOID: { input: any; output: any; }
  /** Arbitrary JSON object scalar */
  ObjectScalar: { input: any; output: any; }
  PNSN: { input: any; output: any; }
};

export type AclAsset = {
  __typename?: 'AclAsset';
  _id: Scalars['MOID']['output'];
  asset?: Maybe<AclAssetObjectUnion>;
  assetId: Scalars['MOID']['output'];
  assetType: AclAssetType;
  isDeleted: Scalars['Boolean']['output'];
  user: UserOutput;
  userId: Scalars['MOID']['output'];
};

export type AclAssetInput = {
  assetId: Scalars['MOID']['input'];
  assetType: AclAssetType;
  userId: Scalars['MOID']['input'];
};

/** Union type for asset object */
export type AclAssetObjectUnion = LessonOutput;

export type AclAssetQuery = {
  assetId?: InputMaybe<Scalars['MOID']['input']>;
  assetType?: InputMaybe<AclAssetType>;
  /** Limit is not required but has a default value */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Page is not required but has a default value */
  page?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['MOID']['input']>;
};

export enum AclAssetType {
  Class = 'CLASS',
  Lesson = 'LESSON'
}

export type AdditionalSchoolOutput = {
  __typename?: 'AdditionalSchoolOutput';
  iaCredit: Scalars['Int']['output'];
  school: SchoolOutput;
  status: AdditionalSchoolStatus;
};

export enum AdditionalSchoolStatus {
  Accepted = 'ACCEPTED',
  Pending = 'PENDING'
}

export type AdminBySchoolOutput = {
  __typename?: 'AdminBySchoolOutput';
  _id?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  role: Roles;
  status: AdditionalSchoolStatus;
};

export type AdminBySchoolOutputPagination = {
  __typename?: 'AdminBySchoolOutputPagination';
  currentPage: Scalars['Int']['output'];
  data: Array<AdminBySchoolOutput>;
  total: Scalars['Int']['output'];
};

export type AdminSchoolInvitationInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['PNSN']['input']>;
  role?: InputMaybe<Roles>;
  school: Scalars['MOID']['input'];
};

export type AnnoucementOutput = {
  __typename?: 'AnnoucementOutput';
  _id: Scalars['MOID']['output'];
  /** Ce champ est uniquement réservé pour l'élève */
  alreadySeen: Scalars['Boolean']['output'];
  attachedFiles: Array<AttachedFileOutput>;
  classInfo: ClassOutput;
  content: AnnouncementContentOutput;
  createdAt: Scalars['DateTime']['output'];
  disciplineIds: Array<Scalars['MOID']['output']>;
  disciplines: Array<DisciplineOutput>;
  /** Ce champ est uniquement réservé pour le professeur */
  isDeleted: Array<UserOutput>;
  isPublished: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  publicationDate?: Maybe<Scalars['DateTime']['output']>;
  /** Ce champ est uniquement réservé pour le professeur */
  seenBy: Array<SeenByOutput>;
  teacher: UserOutput;
};

export type AnnoucementQuery = {
  classId: Scalars['MOID']['input'];
  discipline?: InputMaybe<Scalars['MOID']['input']>;
};

export type AnnoucementsInput = {
  attachedFiles?: InputMaybe<Array<AttachedFileInput>>;
  classInfo: Scalars['MOID']['input'];
  content: AnnouncementContentInput;
  disciplineIds: Array<Scalars['MOID']['input']>;
  isPublished?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  publicationDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnnouncementContentInput = {
  html: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type AnnouncementContentOutput = {
  __typename?: 'AnnouncementContentOutput';
  html: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type AskToLessonInput = {
  audioBase64?: InputMaybe<Scalars['String']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  lessonId: Scalars['MOID']['input'];
  question?: InputMaybe<Scalars['String']['input']>;
};

export type AssetConfig = {
  __typename?: 'AssetConfig';
  _id?: Maybe<Scalars['MOID']['output']>;
  assetId: Scalars['MOID']['output'];
  assetObject?: Maybe<AssetConfigObjectUnion>;
  assetType: AssetConfigType;
  config?: Maybe<Scalars['GraphQLObject']['output']>;
  createdAt: Scalars['DateTime']['output'];
  isDeleted: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AssetConfigInput = {
  assetId: Scalars['MOID']['input'];
  assetType: AssetConfigType;
  config?: InputMaybe<Scalars['GraphQLObject']['input']>;
};

export enum AssetConfigKey {
  ExerciseMaxAttempts = 'EXERCISE_MAX_ATTEMPTS',
  ExerciseWaitingTimeBetweenAttempts = 'EXERCISE_WAITING_TIME_BETWEEN_ATTEMPTS',
  LessonEvaluationDuration = 'LESSON_EVALUATION_DURATION',
  ModuleEvaluationDuration = 'MODULE_EVALUATION_DURATION'
}

/** Union type for asset config object */
export type AssetConfigObjectUnion = ClassOutput | LessonOutput;

/** The type of asset config */
export enum AssetConfigType {
  Classes = 'CLASSES',
  Lesson = 'LESSON'
}

/** Union type for asset object */
export type AssetObjectUnion = ClassOutput | LessonOutput;

export enum AssetType {
  Classes = 'CLASSES',
  Lessons = 'LESSONS'
}

export type AttachedFileInput = {
  asset: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  type: AttachedFileType;
};

export type AttachedFileOutput = {
  __typename?: 'AttachedFileOutput';
  asset: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  type: AttachedFileType;
};

export enum AttachedFileType {
  Audio = 'AUDIO',
  Image = 'IMAGE',
  Other = 'OTHER',
  Pdf = 'PDF',
  Video = 'VIDEO',
  Website = 'WEBSITE',
  Youtube = 'YOUTUBE'
}

export type AttemptQuestionInput = {
  /** Answer for the points student */
  answer?: InputMaybe<Scalars['String']['input']>;
  /** Is correct for the points student */
  isCorrect: Scalars['Boolean']['input'];
  /** Question for the points student */
  question: Scalars['MOID']['input'];
};

export type AttemptQuestionOutput = {
  __typename?: 'AttemptQuestionOutput';
  /** Answer for the points student */
  answer?: Maybe<Scalars['String']['output']>;
  /** Is correct for the points student */
  isCorrect: Scalars['Boolean']['output'];
  /** Question for the points student */
  question: QuestionOutput;
};

export type AuthOutput = {
  __typename?: 'AuthOutput';
  token: TokenOutput;
  user: UserOutput;
};

export type BacInput = {
  date: Scalars['DateTime']['input'];
  series: Array<Scalars['MOID']['input']>;
  year: Scalars['String']['input'];
};

export type BacOutput = {
  __typename?: 'BacOutput';
  _id: Scalars['MOID']['output'];
  date: Scalars['DateTime']['output'];
  series?: Maybe<Array<SerieOutput>>;
  year: Scalars['String']['output'];
};

export enum BadgeCategory {
  Engagement = 'ENGAGEMENT',
  Lessons = 'LESSONS',
  Matieres = 'MATIERES',
  Modules = 'MODULES',
  Parrainage = 'PARRAINAGE',
  Performance = 'PERFORMANCE',
  Progression = 'PROGRESSION'
}

export type BadgeCondition = {
  __typename?: 'BadgeCondition';
  subject?: Maybe<Scalars['MOID']['output']>;
  threshold?: Maybe<Scalars['Float']['output']>;
  type: BadgeConditionType;
};

export type BadgeConditionInput = {
  subject?: InputMaybe<Scalars['MOID']['input']>;
  threshold?: InputMaybe<Scalars['Float']['input']>;
  type: BadgeConditionType;
};

export enum BadgeConditionType {
  FifteenModulesCompleted = 'FIFTEEN_MODULES_COMPLETED',
  FiftyModulesCompleted = 'FIFTY_MODULES_COMPLETED',
  FiftyReferralUsers = 'FIFTY_REFERRAL_USERS',
  FirstLessonCompleted = 'FIRST_LESSON_COMPLETED',
  FirstModuleCompleted = 'FIRST_MODULE_COMPLETED',
  FirstReferralUser = 'FIRST_REFERRAL_USER',
  FiveModulesCompleted = 'FIVE_MODULES_COMPLETED',
  FiveReferralUsers = 'FIVE_REFERRAL_USERS',
  HundredModulesCompleted = 'HUNDRED_MODULES_COMPLETED',
  HundredReferralUsers = 'HUNDRED_REFERRAL_USERS',
  LessonsCompleted = 'LESSONS_COMPLETED',
  MatiereCompleted = 'MATIERE_COMPLETED',
  ModulesCompleted = 'MODULES_COMPLETED',
  ModulesCompletedInMatiere = 'MODULES_COMPLETED_IN_MATIERE',
  SixLessonsCompleted = 'SIX_LESSONS_COMPLETED',
  TenLessonsCompleted = 'TEN_LESSONS_COMPLETED',
  TenModulesCompleted = 'TEN_MODULES_COMPLETED',
  TenReferralUsers = 'TEN_REFERRAL_USERS',
  ThirtyFiveModulesCompleted = 'THIRTY_FIVE_MODULES_COMPLETED',
  ThreeLessonsCompleted = 'THREE_LESSONS_COMPLETED',
  TwentyFiveModulesCompleted = 'TWENTY_FIVE_MODULES_COMPLETED',
  TwentyModulesCompleted = 'TWENTY_MODULES_COMPLETED',
  TwentyReferralUsers = 'TWENTY_REFERRAL_USERS',
  TwoHundredModulesCompleted = 'TWO_HUNDRED_MODULES_COMPLETED'
}

export type BadgeOutput = {
  __typename?: 'BadgeOutput';
  _id: Scalars['MOID']['output'];
  badge: BadgeOutput;
  category: BadgeCategory;
  condition: BadgeCondition;
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  subject_name?: Maybe<Scalars['String']['output']>;
};

export type BadgeProgress = {
  __typename?: 'BadgeProgress';
  badge: BadgeOutput;
  currentProgress: Scalars['Float']['output'];
  progressPercentage: Scalars['Float']['output'];
  requiredProgress: Scalars['Float']['output'];
};

export type BadgeWithUserStatus = {
  __typename?: 'BadgeWithUserStatus';
  _id: Scalars['MOID']['output'];
  badge: BadgeOutput;
  category: BadgeCategory;
  condition: BadgeCondition;
  description: Scalars['String']['output'];
  earnedAt?: Maybe<Scalars['DateTime']['output']>;
  isEarned: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  subject_name?: Maybe<Scalars['String']['output']>;
  user: UserOutput;
};

export enum BictorysChargeType {
  CardPaymentObject = 'CARD_PAYMENT_OBJECT',
  CheckoutLinkObject = 'CHECKOUT_LINK_OBJECT',
  MobilePaymentObject = 'MOBILE_PAYMENT_OBJECT'
}

export type BlockedLessonsByStudentQuery = {
  classId: Scalars['MOID']['input'];
  studentId: Scalars['MOID']['input'];
};

export type CampaignOutput = {
  __typename?: 'CampaignOutput';
  _id: Scalars['MOID']['output'];
  campaignAmount: Scalars['Float']['output'];
  campaignClicks: Scalars['Float']['output'];
  campaignEndDate: Scalars['DateTime']['output'];
  campaignLink: Scalars['String']['output'];
  campaignName: Scalars['String']['output'];
  campaignPriority: Scalars['Float']['output'];
  campaignResource: Scalars['String']['output'];
  campaignStartDate: Scalars['DateTime']['output'];
  campaignStatus: Scalars['String']['output'];
  campaignType: Scalars['String']['output'];
  campaignViews: Scalars['Float']['output'];
  company: CompanyOutput;
};

export type CampaignStatDaily = {
  __typename?: 'CampaignStatDaily';
  clicks: Scalars['Float']['output'];
  date: Scalars['String']['output'];
  views: Scalars['Float']['output'];
};

export type CampaignStatDailyOutput = {
  __typename?: 'CampaignStatDailyOutput';
  data: Array<CampaignStatDaily>;
};

export type CampaignStatOutput = {
  __typename?: 'CampaignStatOutput';
  _id: Scalars['MOID']['output'];
  byClass?: Maybe<Array<ClassStat>>;
  byGender?: Maybe<Array<GenderStat>>;
  byRegion?: Maybe<Array<RegionStat>>;
};

export enum CampaignStatus {
  Completed = 'COMPLETED',
  Pending = 'PENDING',
  Running = 'RUNNING'
}

export enum CampaignType {
  AudioPreLesson = 'AUDIO_PRE_LESSON',
  MainBanner = 'MAIN_BANNER',
  TextLessonBanner = 'TEXT_LESSON_BANNER',
  TextLessonPopup = 'TEXT_LESSON_POPUP',
  WelcomePopup = 'WELCOME_POPUP'
}

export type CampaignsInput = {
  campaignAmount: Scalars['Float']['input'];
  campaignDuration: Scalars['Float']['input'];
  campaignLink: Scalars['String']['input'];
  campaignName: Scalars['String']['input'];
  campaignPriority: Scalars['Float']['input'];
  campaignResource: Scalars['String']['input'];
  campaignStartDate: Scalars['DateTime']['input'];
  campaignType: CampaignType;
  company: Scalars['MOID']['input'];
};

export type CampaignsInputUpdate = {
  campaignAmount?: InputMaybe<Scalars['Float']['input']>;
  campaignClick?: InputMaybe<Scalars['Float']['input']>;
  campaignDuration?: InputMaybe<Scalars['Float']['input']>;
  campaignLink?: InputMaybe<Scalars['String']['input']>;
  campaignName?: InputMaybe<Scalars['String']['input']>;
  campaignPriority?: InputMaybe<Scalars['Float']['input']>;
  campaignResource?: InputMaybe<Scalars['String']['input']>;
  campaignStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  campaignStatus?: InputMaybe<CampaignStatus>;
  campaignType?: InputMaybe<CampaignType>;
  campaignView?: InputMaybe<Scalars['Float']['input']>;
  company?: InputMaybe<Scalars['MOID']['input']>;
};

export type CampaignsInputUpdateStat = {
  campaignClick?: InputMaybe<Scalars['Float']['input']>;
  campaignView?: InputMaybe<Scalars['Float']['input']>;
};

export type CampaignsPaginationOutput = {
  __typename?: 'CampaignsPaginationOutput';
  currentPage: Scalars['Int']['output'];
  data: Array<CampaignOutput>;
  total: Scalars['Int']['output'];
};

export type CampaignsQuery = {
  campaignName?: InputMaybe<Scalars['String']['input']>;
  campaignStatus?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['MOID']['input']>;
  /** Limit is not required but has a default value */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Page is not required but has a default value */
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type CampaignsStatsOutput = {
  __typename?: 'CampaignsStatsOutput';
  totalCampaigns: Scalars['Float']['output'];
  totalCompleted: Scalars['Float']['output'];
  totalOngoing: Scalars['Float']['output'];
  totalPending: Scalars['Float']['output'];
};

export type CancelSectionGenerationInput = {
  lessonId: Scalars['MOID']['input'];
  schoolId?: InputMaybe<Scalars['MOID']['input']>;
};

export type CategoryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CategoryOutput = {
  __typename?: 'CategoryOutput';
  _id: Scalars['MOID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type ChapterContentInput = {
  html?: InputMaybe<Scalars['String']['input']>;
  markdown?: InputMaybe<Scalars['String']['input']>;
  text?: Scalars['String']['input'];
};

export type ChapterContentOutput = {
  __typename?: 'ChapterContentOutput';
  html?: Maybe<Scalars['String']['output']>;
  markdown?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type ChapterInput = {
  content?: InputMaybe<ChapterContentInput>;
  lessonId: Scalars['MOID']['input'];
  mediaContent?: Array<MediaContentInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Float']['input'];
  questionId?: InputMaybe<Scalars['MOID']['input']>;
  sectionId: Scalars['MOID']['input'];
};

export type ChapterOutput = {
  __typename?: 'ChapterOutput';
  _id?: Maybe<Scalars['MOID']['output']>;
  content?: Maybe<ChapterContentOutput>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  lesson?: Maybe<LessonOutput>;
  lessonId: Scalars['MOID']['output'];
  mediaContent: Array<MediaContentOutput>;
  name?: Maybe<Scalars['String']['output']>;
  position: Scalars['Float']['output'];
  question?: Maybe<QuestionOutput>;
  questionId?: Maybe<Scalars['MOID']['output']>;
  section?: Maybe<SectionOutput>;
  sectionId: Scalars['MOID']['output'];
};

export type ChapterQueryInput = {
  lessonId: Scalars['MOID']['input'];
  sectionId?: InputMaybe<Scalars['MOID']['input']>;
};

export type ChapterQuestionInput = {
  lessonId: Scalars['MOID']['input'];
  position: Scalars['Float']['input'];
  question: QuestionInput;
  sectionId: Scalars['MOID']['input'];
};

export type ChapterUpsertInput = {
  content?: InputMaybe<ChapterContentInput>;
  id?: InputMaybe<Scalars['MOID']['input']>;
  lessonId: Scalars['MOID']['input'];
  mediaContent?: Array<MediaContentInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Float']['input'];
  questionId?: InputMaybe<Scalars['MOID']['input']>;
  sectionId: Scalars['MOID']['input'];
};

export type ChapterUpsertOutput = {
  __typename?: 'ChapterUpsertOutput';
  chaptersUpserted: Scalars['Int']['output'];
  textError?: Maybe<Scalars['String']['output']>;
};

export type ChargeOutput = {
  __typename?: 'ChargeOutput';
  chargeId?: Maybe<Scalars['String']['output']>;
  link: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  opToken?: Maybe<Scalars['String']['output']>;
  qrCode?: Maybe<Scalars['String']['output']>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
  type: BictorysChargeType;
};

export type ChariowClassMapping = {
  __typename?: 'ChariowClassMapping';
  _id: Scalars['MOID']['output'];
  classId: Scalars['MOID']['output'];
  createdAt: Scalars['DateTime']['output'];
  isActive: Scalars['Boolean']['output'];
  productId: Scalars['String']['output'];
  storeId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ChariowClassMappingFilterInput = {
  classId?: InputMaybe<Scalars['MOID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['String']['input']>;
};

export type ChatbotResponseOutput = {
  __typename?: 'ChatbotResponseOutput';
  answer?: Maybe<Scalars['String']['output']>;
  audioBase64?: Maybe<Scalars['String']['output']>;
  lessonId: Scalars['String']['output'];
  question?: Maybe<Scalars['String']['output']>;
};

export type ClassActivePromoOfferOutput = {
  __typename?: 'ClassActivePromoOfferOutput';
  basePrice: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  percentOff: Scalars['Int']['output'];
  promoPrice: Scalars['Float']['output'];
  validUntil: Scalars['DateTime']['output'];
};

export type ClassByConfigNumbersQuery = {
  hasToPayToAccess?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  /** Limit is not required but has a default value */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Page is not required but has a default value */
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ClassCountBySchoolInput = {
  schoolId: Scalars['MOID']['input'];
};

export type ClassCountBySchoolOutput = {
  __typename?: 'ClassCountBySchoolOutput';
  classesCount: Scalars['Int']['output'];
  lessonsCount: Scalars['Int']['output'];
  studentsCount: Scalars['Int']['output'];
  teachersCount: Scalars['Int']['output'];
};

export type ClassCountByTeacherOutput = {
  __typename?: 'ClassCountByTeacherOutput';
  classesCount: Scalars['Int']['output'];
  disciplinesCount: Scalars['Int']['output'];
  lessonsCount: Scalars['Int']['output'];
  studentsCount: Scalars['Int']['output'];
};

export type ClassCountByTeacherQuery = {
  schoolId?: InputMaybe<Scalars['MOID']['input']>;
};

export type ClassDisciplineInput = {
  discipline: Scalars['MOID']['input'];
  teacher?: InputMaybe<TeacherDisciplineInput>;
};

export type ClassDisciplineOutput = {
  __typename?: 'ClassDisciplineOutput';
  discipline: DisciplineOutput;
  lessonsCount?: Maybe<Scalars['Int']['output']>;
  status: ClassDisciplineStatus;
  teacher?: Maybe<FilteredUserOutput>;
};

export enum ClassDisciplineStatus {
  Assigned = 'ASSIGNED',
  Unassigned = 'UNASSIGNED'
}

export type ClassInput = {
  cover?: InputMaybe<Scalars['String']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  landingPresentationMarkdown?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  tags?: Array<Scalars['String']['input']>;
};

export type ClassLandingAdminOutput = {
  __typename?: 'ClassLandingAdminOutput';
  accentColor: Scalars['String']['output'];
  classId: Scalars['MOID']['output'];
  faq: Array<ClassLandingFaqOutput>;
  presentationMarkdown?: Maybe<Scalars['String']['output']>;
  previewLesson?: Maybe<ClassLandingPreviewLessonOutput>;
  slug: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ClassLandingDisciplineOutput = {
  __typename?: 'ClassLandingDisciplineOutput';
  disciplineId?: Maybe<Scalars['MOID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  teacher?: Maybe<Scalars['String']['output']>;
};

export type ClassLandingFaqInput = {
  answerMarkdown: Scalars['String']['input'];
  question: Scalars['String']['input'];
};

export type ClassLandingFaqOutput = {
  __typename?: 'ClassLandingFaqOutput';
  answerMarkdown: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

export type ClassLandingOutput = {
  __typename?: 'ClassLandingOutput';
  accentColor: Scalars['String']['output'];
  classId: Scalars['MOID']['output'];
  cover?: Maybe<Scalars['String']['output']>;
  disciplines: Array<ClassLandingDisciplineOutput>;
  landingFaq: Array<ClassLandingFaqOutput>;
  landingPresentationMarkdown?: Maybe<Scalars['String']['output']>;
  lessonsCount: Scalars['Int']['output'];
  letter?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  payToAccess: Scalars['Boolean']['output'];
  previewLesson?: Maybe<ClassLandingPreviewLessonOutput>;
  promoYear?: Maybe<Scalars['String']['output']>;
  school?: Maybe<ClassLandingSchoolOutput>;
  slug: Scalars['String']['output'];
  studentsCount: Scalars['Int']['output'];
  subscriptionAccessMode?: Maybe<SubscriptionAccessMode>;
  subscriptionCurrency?: Maybe<Scalars['String']['output']>;
  subscriptionDurationDays?: Maybe<Scalars['Int']['output']>;
  subscriptionPricing?: Maybe<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  teacher?: Maybe<ClassLandingTeacherOutput>;
};

export type ClassLandingPreviewLessonOutput = {
  __typename?: 'ClassLandingPreviewLessonOutput';
  id: Scalars['MOID']['output'];
  name: Scalars['String']['output'];
};

export type ClassLandingSchoolOutput = {
  __typename?: 'ClassLandingSchoolOutput';
  id?: Maybe<Scalars['MOID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ClassLandingTeacherOutput = {
  __typename?: 'ClassLandingTeacherOutput';
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['MOID']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type ClassOutput = {
  __typename?: 'ClassOutput';
  _id: Scalars['MOID']['output'];
  accessCode?: Maybe<Scalars['String']['output']>;
  activePromoOffer?: Maybe<ClassActivePromoOfferOutput>;
  alreadyHasSubscriptionPackage: Scalars['Boolean']['output'];
  assetConfigs?: Maybe<Array<AssetConfig>>;
  categories?: Maybe<Array<SchoolCategory>>;
  classRef?: Maybe<ClassOutput>;
  cover?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  disciplines?: Maybe<Array<ClassDisciplineOutput>>;
  isPublic: Scalars['Boolean']['output'];
  landingFaq: Array<ClassLandingFaqOutput>;
  landingPresentationMarkdown?: Maybe<Scalars['String']['output']>;
  landingSlug?: Maybe<Scalars['String']['output']>;
  lessonsCount: Scalars['Int']['output'];
  letter: Scalars['String']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notSeenAnnouncementCount: Scalars['Int']['output'];
  payToAccess?: Maybe<Scalars['Boolean']['output']>;
  promoEnabled: Scalars['Boolean']['output'];
  promoYear?: Maybe<Scalars['String']['output']>;
  school?: Maybe<SchoolOutput>;
  serie?: Maybe<SerieOutput>;
  studentsCount: Scalars['Int']['output'];
  subscriptionAccessMode?: Maybe<SubscriptionAccessMode>;
  subscriptionDurationDays?: Maybe<Scalars['Int']['output']>;
  subscriptionPricing?: Maybe<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  teacher?: Maybe<FilteredUserOutput>;
  teachersCount: Scalars['Int']['output'];
};

export type ClassQuery = {
  category?: InputMaybe<SchoolCategory>;
  name?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ClassReminderCampaignOutput = {
  __typename?: 'ClassReminderCampaignOutput';
  _id?: Maybe<Scalars['MOID']['output']>;
  isActive: Scalars['Boolean']['output'];
  sendHourLocal?: Maybe<Scalars['Int']['output']>;
  sendMinuteLocal?: Maybe<Scalars['Int']['output']>;
  templates: Array<ClassReminderTemplateOutput>;
  timezone?: Maybe<Scalars['String']['output']>;
  waveOffsetsDays: Array<Scalars['Int']['output']>;
};

export type ClassReminderTemplateInput = {
  content: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type ClassReminderTemplateOutput = {
  __typename?: 'ClassReminderTemplateOutput';
  content: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ClassResourcesStudentValidation = {
  accessCode: Scalars['String']['input'];
};

export type ClassRessoucesInput = {
  classId: Scalars['MOID']['input'];
  students?: Array<Scalars['String']['input']>;
};

export enum ClassRessoucesStudentStatus {
  Accepted = 'ACCEPTED',
  AwaitingForPayment = 'AWAITING_FOR_PAYMENT',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED'
}

export type ClassRessoucesToDeleteInput = {
  classId: Scalars['MOID']['input'];
  students?: Array<Scalars['String']['input']>;
};

export type ClassRevenueAccessStatsOutput = {
  __typename?: 'ClassRevenueAccessStatsOutput';
  activePaidStudentsCount: Scalars['Int']['output'];
  inactivePaidStudentsCount: Scalars['Int']['output'];
  multiPaidStudents: Array<ClassRevenueMultiPaidStudentOutput>;
  multiPaidStudentsCount: Scalars['Int']['output'];
  neverPaidStudentsCount: Scalars['Int']['output'];
  totalTrackedStudentsCount: Scalars['Int']['output'];
};

export type ClassRevenueBuyerOutput = {
  __typename?: 'ClassRevenueBuyerOutput';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ClassRevenueDashboardOutput = {
  __typename?: 'ClassRevenueDashboardOutput';
  accessStats: ClassRevenueAccessStatsOutput;
  paymentMethods: Array<ClassRevenuePaymentMethodOutput>;
  payments: ClassRevenuePaymentsPaginationOutput;
  summary: ClassRevenueSummaryOutput;
  trend: Array<ClassRevenueTrendPointOutput>;
};

export type ClassRevenueDashboardQuery = {
  classId: Scalars['MOID']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Limit is not required but has a default value */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Page is not required but has a default value */
  page?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ClassRevenueMultiPaidPaymentOutput = {
  __typename?: 'ClassRevenueMultiPaidPaymentOutput';
  amount: Scalars['Float']['output'];
  amountSource: Scalars['String']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  isEstimated: Scalars['Boolean']['output'];
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  paymentMethod: Scalars['String']['output'];
  status: Scalars['String']['output'];
  transactionId: Scalars['String']['output'];
};

export type ClassRevenueMultiPaidStudentOutput = {
  __typename?: 'ClassRevenueMultiPaidStudentOutput';
  currency?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastPaidAt?: Maybe<Scalars['DateTime']['output']>;
  payments: Array<ClassRevenueMultiPaidPaymentOutput>;
  phone?: Maybe<Scalars['String']['output']>;
  purchasesCount: Scalars['Int']['output'];
  totalAmount: Scalars['Float']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type ClassRevenuePaymentMethodOutput = {
  __typename?: 'ClassRevenuePaymentMethodOutput';
  paymentMethod: Scalars['String']['output'];
  paymentsCount: Scalars['Int']['output'];
  revenue: Scalars['Float']['output'];
};

export type ClassRevenuePaymentOutput = {
  __typename?: 'ClassRevenuePaymentOutput';
  amount: Scalars['Float']['output'];
  amountSource: Scalars['String']['output'];
  buyer: ClassRevenueBuyerOutput;
  checkoutCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  claimedAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  isEstimated: Scalars['Boolean']['output'];
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  paymentMethod: Scalars['String']['output'];
  status: Scalars['String']['output'];
  transactionId: Scalars['String']['output'];
};

export type ClassRevenuePaymentsPaginationOutput = {
  __typename?: 'ClassRevenuePaymentsPaginationOutput';
  currentPage: Scalars['Int']['output'];
  data: Array<ClassRevenuePaymentOutput>;
  total: Scalars['Int']['output'];
};

export type ClassRevenueSummaryOutput = {
  __typename?: 'ClassRevenueSummaryOutput';
  averageTicket: Scalars['Float']['output'];
  claimedPaymentsCount: Scalars['Int']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  estimatedRevenue: Scalars['Float']['output'];
  paymentsCount: Scalars['Int']['output'];
  totalRevenue: Scalars['Float']['output'];
  unclaimedPaymentsCount: Scalars['Int']['output'];
};

export type ClassRevenueTrendPointOutput = {
  __typename?: 'ClassRevenueTrendPointOutput';
  date: Scalars['String']['output'];
  estimatedRevenue: Scalars['Float']['output'];
  paymentsCount: Scalars['Int']['output'];
  revenue: Scalars['Float']['output'];
};

export type ClassSchoolCreationOutput = {
  __typename?: 'ClassSchoolCreationOutput';
  classId: Scalars['MOID']['output'];
  created: Scalars['Boolean']['output'];
  errors: Array<Scalars['String']['output']>;
};

export type ClassSchoolInput = {
  classRef?: InputMaybe<Scalars['MOID']['input']>;
  cover?: InputMaybe<Scalars['String']['input']>;
  disciplines?: InputMaybe<Array<ClassDisciplineInput>>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  landingPresentationMarkdown?: InputMaybe<Scalars['String']['input']>;
  letter: Scalars['String']['input'];
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  payToAccess?: Scalars['Boolean']['input'];
  pricing?: InputMaybe<Scalars['String']['input']>;
  promoEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  promoYear: Scalars['String']['input'];
  school: Scalars['MOID']['input'];
  serie?: InputMaybe<Scalars['MOID']['input']>;
  subscriptionAccessMode?: InputMaybe<SubscriptionAccessMode>;
  subscriptionDurationDays?: InputMaybe<Scalars['Float']['input']>;
  tags?: Array<Scalars['String']['input']>;
};

export type ClassSchoolTeacherOutput = {
  __typename?: 'ClassSchoolTeacherOutput';
  _id: Scalars['MOID']['output'];
  accessCode?: Maybe<Scalars['String']['output']>;
  alreadyHasSubscriptionPackage: Scalars['Boolean']['output'];
  assetConfigs?: Maybe<Array<AssetConfig>>;
  categories?: Maybe<Array<SchoolCategory>>;
  classRef?: Maybe<ClassOutput>;
  cover?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  disciplines: Array<DisciplineOutput>;
  isPublic: Scalars['Boolean']['output'];
  landingFaq: Array<ClassLandingFaqOutput>;
  landingPresentationMarkdown?: Maybe<Scalars['String']['output']>;
  landingSlug?: Maybe<Scalars['String']['output']>;
  lessonsCount: Scalars['Int']['output'];
  letter: Scalars['String']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notSeenAnnouncementCount: Scalars['Int']['output'];
  payToAccess?: Maybe<Scalars['Boolean']['output']>;
  promoEnabled: Scalars['Boolean']['output'];
  promoYear?: Maybe<Scalars['String']['output']>;
  school?: Maybe<SchoolOutput>;
  serie?: Maybe<SerieOutput>;
  studentsCount: Scalars['Int']['output'];
  subscriptionAccessMode?: Maybe<SubscriptionAccessMode>;
  subscriptionDurationDays?: Maybe<Scalars['Int']['output']>;
  subscriptionPricing?: Maybe<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  teacher?: Maybe<FilteredUserOutput>;
  teachersCount: Scalars['Int']['output'];
};

export type ClassSchoolTeacherQuery = {
  promoYear?: InputMaybe<Scalars['String']['input']>;
  school?: InputMaybe<Scalars['MOID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ClassSchoolUpdateOutput = {
  __typename?: 'ClassSchoolUpdateOutput';
  classId: Scalars['MOID']['output'];
  errors: Array<Scalars['String']['output']>;
  updated: Scalars['Boolean']['output'];
};

export type ClassStat = {
  __typename?: 'ClassStat';
  class: Scalars['String']['output'];
  clicks: Scalars['Float']['output'];
  views: Scalars['Float']['output'];
};

export type ClassSubjectByStudent = {
  classId?: InputMaybe<Scalars['MOID']['input']>;
};

export type ClassTeacherInput = {
  classRef?: InputMaybe<Scalars['MOID']['input']>;
  cover?: InputMaybe<Scalars['String']['input']>;
  disciplines?: InputMaybe<Array<ClassDisciplineInput>>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  landingPresentationMarkdown?: InputMaybe<Scalars['String']['input']>;
  letter: Scalars['String']['input'];
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  payToAccess?: Scalars['Boolean']['input'];
  pricing?: InputMaybe<Scalars['String']['input']>;
  promoEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  promoYear: Scalars['String']['input'];
  serie?: InputMaybe<Scalars['MOID']['input']>;
  subscriptionAccessMode?: InputMaybe<SubscriptionAccessMode>;
  subscriptionDurationDays?: InputMaybe<Scalars['Float']['input']>;
  tags?: Array<Scalars['String']['input']>;
};

export type CoefInput = {
  coef?: InputMaybe<Scalars['Float']['input']>;
  serie?: InputMaybe<Scalars['MOID']['input']>;
};

export type CoefOutput = {
  __typename?: 'CoefOutput';
  coef?: Maybe<Scalars['Float']['output']>;
  serie?: Maybe<SerieOutput>;
};

export type CompanyInput = {
  address: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  ninea: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type CompanyOutput = {
  __typename?: 'CompanyOutput';
  _id: Scalars['MOID']['output'];
  address: Scalars['String']['output'];
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  ninea: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type CompanyQuery = {
  id?: InputMaybe<Scalars['MOID']['input']>;
  /** Limit is not required but has a default value */
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Page is not required but has a default value */
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type ConclusionOutput = {
  __typename?: 'ConclusionOutput';
  commentaire?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['Float']['output']>;
};

export type Configuration = {
  __typename?: 'Configuration';
  description: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  module: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Available configuration keys for the application */
export enum ConfigurationKey {
  ExerciseBonusPointsQuickCompletion = 'EXERCISE_BONUS_POINTS_QUICK_COMPLETION',
  ExerciseDefaultDuration = 'EXERCISE_DEFAULT_DURATION',
  ExerciseMaxAttempts = 'EXERCISE_MAX_ATTEMPTS',
  ExerciseMaxDuration = 'EXERCISE_MAX_DURATION',
  ExerciseMaxQuestions = 'EXERCISE_MAX_QUESTIONS',
  ExerciseMinDuration = 'EXERCISE_MIN_DURATION',
  ExerciseMinQuestions = 'EXERCISE_MIN_QUESTIONS',
  ExerciseMinScoreToPass = 'EXERCISE_MIN_SCORE_TO_PASS',
  ExercisePointsPerCorrectAnswer = 'EXERCISE_POINTS_PER_CORRECT_ANSWER',
  ExerciseWaitingTimeBetweenAttempts = 'EXERCISE_WAITING_TIME_BETWEEN_ATTEMPTS',
  GenerationAudioCreditCost = 'GENERATION_AUDIO_CREDIT_COST',
  GenerationChatbotCreditCost = 'GENERATION_CHATBOT_CREDIT_COST',
  GenerationFlashcardCreditCost = 'GENERATION_FLASHCARD_CREDIT_COST',
  GenerationGlossaryCreditCost = 'GENERATION_GLOSSARY_CREDIT_COST',
  GenerationPodcastCreditCost = 'GENERATION_PODCAST_CREDIT_COST',
  GenerationQuizCreditCost = 'GENERATION_QUIZ_CREDIT_COST',
  GenerationSectionCreditCost = 'GENERATION_SECTION_CREDIT_COST',
  GenerationStoryCreditCost = 'GENERATION_STORY_CREDIT_COST',
  GenerationSummaryCreditCost = 'GENERATION_SUMMARY_CREDIT_COST',
  IsCreditPurchaseEnabled = 'IS_CREDIT_PURCHASE_ENABLED',
  IsOtpEnabled = 'IS_OTP_ENABLED',
  JobTimeoutMs = 'JOB_TIMEOUT_MS',
  LessonEvaluationDuration = 'LESSON_EVALUATION_DURATION',
  ModuleEvaluationDuration = 'MODULE_EVALUATION_DURATION',
  PaymentOption = 'PAYMENT_OPTION',
  QuestionsDefaultPaginationLimit = 'QUESTIONS_DEFAULT_PAGINATION_LIMIT',
  QuestionsMinResponses = 'QUESTIONS_MIN_RESPONSES',
  QuestionsRandomSearchLimit = 'QUESTIONS_RANDOM_SEARCH_LIMIT',
  QuizMaxAttempts = 'QUIZ_MAX_ATTEMPTS',
  QuizMinScoreForBadge = 'QUIZ_MIN_SCORE_FOR_BADGE',
  QuizNewQuestionsPercentage = 'QUIZ_NEW_QUESTIONS_PERCENTAGE',
  QuizPointsPerCorrectAnswer = 'QUIZ_POINTS_PER_CORRECT_ANSWER',
  QuizTotalQuestions = 'QUIZ_TOTAL_QUESTIONS',
  QuizWaitingTimeMinutes = 'QUIZ_WAITING_TIME_MINUTES',
  QuotaConfig = 'QUOTA_CONFIG',
  ScreenCaptureEnabled = 'SCREEN_CAPTURE_ENABLED'
}

/** Union type for asset object */
export type ConsumedCreditAssetObjectUnion = LessonOutput;

export type ConsumedCreditInput = {
  assetId?: InputMaybe<Scalars['MOID']['input']>;
  assetType?: InputMaybe<CreditAssetType>;
  consumedCredit: Scalars['Float']['input'];
  description: Scalars['String']['input'];
  schoolId?: InputMaybe<Scalars['MOID']['input']>;
  userId: Scalars['MOID']['input'];
};

export type ConsumedCreditQuery = {
  assetId?: InputMaybe<Scalars['MOID']['input']>;
  assetType?: InputMaybe<CreditAssetType>;
  /** Limit is not required but has a default value */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Page is not required but has a default value */
  page?: InputMaybe<Scalars['Int']['input']>;
  schoolId?: InputMaybe<Scalars['MOID']['input']>;
  userId?: InputMaybe<Scalars['MOID']['input']>;
};

export type ConsumedCreditsOutput = {
  __typename?: 'ConsumedCreditsOutput';
  _id: Scalars['MOID']['output'];
  asset?: Maybe<ConsumedCreditAssetObjectUnion>;
  assetType?: Maybe<CreditAssetType>;
  consumedCredit: Scalars['Float']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<PaymentWay>;
  school?: Maybe<SchoolOutput>;
  schoolId?: Maybe<Scalars['MOID']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<CreditTransactionType>;
  user: UserOutput;
  userId: Scalars['MOID']['output'];
};

export type ConsumedCreditsPagination = {
  __typename?: 'ConsumedCreditsPagination';
  currentPage: Scalars['Int']['output'];
  data: Array<ConsumedCreditsOutput>;
  total: Scalars['Int']['output'];
};

export type Content = {
  __typename?: 'Content';
  html?: Maybe<Scalars['String']['output']>;
  markdown?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type ContentInput = {
  html?: InputMaybe<Scalars['String']['input']>;
  markdown?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};

export type ContentOutput = {
  __typename?: 'ContentOutput';
  html: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  type: SectionType;
};

export type ContentTipsInput = {
  html?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ContentTipsType = {
  __typename?: 'ContentTipsType';
  html?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type ContentUpdateInput = {
  html?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SectionType>;
};

export type ConversionMetrics = {
  __typename?: 'ConversionMetrics';
  conversionRate: Scalars['Float']['output'];
  convertedToPayingCustomers: Scalars['Int']['output'];
  totalFreeTrials: Scalars['Int']['output'];
};

export type CountriesOutput = {
  __typename?: 'CountriesOutput';
  _id: Scalars['MOID']['output'];
  code: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CountryUpdateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CouponIntput = {
  customCode?: InputMaybe<Scalars['String']['input']>;
  discountType: CouponType;
  discountValue: Scalars['Float']['input'];
  expirationDate: Scalars['DateTime']['input'];
  packages: Array<Scalars['MOID']['input']>;
  usageLimit: Scalars['Float']['input'];
};

export type CouponOutput = {
  __typename?: 'CouponOutput';
  _id: Scalars['MOID']['output'];
  code: Scalars['String']['output'];
  discountType: Scalars['String']['output'];
  discountValue: Scalars['Float']['output'];
  expirationDate: Scalars['DateTime']['output'];
  isDeleted: Scalars['Boolean']['output'];
  packages: Array<SubscriptionPackagesOutput>;
  status: Scalars['String']['output'];
  usageLimit: Scalars['Float']['output'];
  usedCount: Scalars['Float']['output'];
  users: Array<UserOutput>;
};

export type CouponUpdateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  customCode?: InputMaybe<Scalars['String']['input']>;
  discountType?: InputMaybe<CouponType>;
  discountValue?: InputMaybe<Scalars['Float']['input']>;
  expirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  packages?: InputMaybe<Array<Scalars['MOID']['input']>>;
  usageLimit?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateBadgeInput = {
  category: BadgeCategory;
  condition: BadgeConditionInput;
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  subject_name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateChariowClassMappingInput = {
  classId: Scalars['MOID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productId: Scalars['String']['input'];
  storeId: Scalars['String']['input'];
};

export type CreateConfigurationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
  module: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type CreateCountryInput = {
  code: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateGiftInput = {
  /** Image of the gift */
  image?: InputMaybe<Scalars['String']['input']>;
  /** Is the gift private */
  isPrivate?: Scalars['Boolean']['input'];
  /** Name of the gift */
  name: Scalars['String']['input'];
  /** Points of the gift */
  points: Scalars['Float']['input'];
  /** Rank to get the gift */
  ranking?: InputMaybe<Scalars['String']['input']>;
  /** Status of the gift */
  status: GiftStatus;
};

export type CreateGiftRequestInput = {
  /** Example field (placeholder) */
  exampleField: Scalars['Int']['input'];
};

export type CreateModuleInput = {
  /** Example field (placeholder) */
  exampleField: Scalars['Int']['input'];
};

export type CreateMultipleQuestionsExamGenerationConfigInput = {
  /** exam generation config id */
  examGenerationConfigId: Scalars['MOID']['input'];
  /** questions */
  questions: Array<QuestionInput>;
};

export type CreateNotificationInput = {
  /** Example field (placeholder) */
  exampleField: Scalars['Int']['input'];
};

export type CreateSchoolInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<SchoolCategory>>;
  contact?: InputMaybe<SchoolContactInput>;
  iaCredit?: InputMaybe<Scalars['Float']['input']>;
  level?: InputMaybe<SchoolLevel>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['MOID']['input']>;
  status?: InputMaybe<SchoolStatus>;
  type?: SchoolType;
};

export type CreateSociumIntegrationInput = {
  allowedRedirectDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  environment?: Scalars['String']['input'];
  name: Scalars['String']['input'];
  regionId?: InputMaybe<Scalars['MOID']['input']>;
  schoolId?: InputMaybe<Scalars['MOID']['input']>;
  schoolName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSubscriptionPackagesInput = {
  assetId?: InputMaybe<Scalars['MOID']['input']>;
  assetType?: InputMaybe<AssetType>;
  concernBy?: InputMaybe<Array<ParentRole>>;
  countries?: Array<Scalars['String']['input']>;
  currency: Currency;
  description: Scalars['String']['input'];
  duration?: InputMaybe<Scalars['Int']['input']>;
  isLifetime?: InputMaybe<Scalars['Boolean']['input']>;
  isTaxable?: Scalars['Boolean']['input'];
  pricing: Scalars['String']['input'];
  title: Scalars['String']['input'];
  type: UserPayment;
};

export type CreateTipsCategoryInput = {
  description: Scalars['String']['input'];
  icon?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateTipsInput = {
  audio?: InputMaybe<Scalars['String']['input']>;
  category: Scalars['MOID']['input'];
  content?: InputMaybe<ContentTipsInput>;
  description: Scalars['String']['input'];
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  type: TipType;
};

export enum CreditAssetType {
  Lesson = 'LESSON'
}

export enum CreditTransactionType {
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

export type DefinitionContentInput = {
  html: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type DeleteAdminSchoolFromSchoolInput = {
  adminEmail: Scalars['String']['input'];
  schoolId: Scalars['MOID']['input'];
};

export type DeleteAdminsFromSchoolInput = {
  adminEmails: Array<Scalars['String']['input']>;
  school: Scalars['MOID']['input'];
};

export type DeleteMultipleQuestionsExamGenerationConfigInput = {
  /** exam generation config id */
  examGenerationConfigId: Scalars['MOID']['input'];
  /** ids of questions */
  questionIds: Array<Scalars['MOID']['input']>;
};

export type DeleteTeacherFromSchoolInput = {
  schoolId: Scalars['MOID']['input'];
  teacherEmail: Scalars['String']['input'];
};

export type DeleteTeachersFromSchoolInput = {
  school: Scalars['MOID']['input'];
  teachersEmails: Array<Scalars['String']['input']>;
};

export type DevelopmentOutput = {
  __typename?: 'DevelopmentOutput';
  subParts: Array<SubPartOutput>;
};

/** Difficulty level */
export enum DifficultyLevel {
  Easy = 'EASY',
  Hard = 'HARD',
  Medium = 'MEDIUM'
}

export type DisciplineInput = {
  categories?: InputMaybe<Array<Scalars['MOID']['input']>>;
  coefs?: InputMaybe<Array<CoefInput>>;
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  type?: InputMaybe<DisciplineType>;
  types?: InputMaybe<Array<DisciplineType>>;
};

export type DisciplineOutput = {
  __typename?: 'DisciplineOutput';
  _id: Scalars['MOID']['output'];
  categories?: Maybe<Array<CategoryOutput>>;
  coefs?: Maybe<Array<CoefOutput>>;
  countries?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  type: DisciplineType;
  types?: Maybe<Array<DisciplineType>>;
};

export type DisciplineOutputPagination = {
  __typename?: 'DisciplineOutputPagination';
  currentPage: Scalars['Int']['output'];
  data: Array<DisciplineOutput>;
  total: Scalars['Int']['output'];
};

export type DisciplineQueryInput = {
  limit?: InputMaybe<Scalars['Float']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<DisciplineType>;
};

export enum DisciplineType {
  Other = 'OTHER',
  Professional = 'PROFESSIONAL',
  School = 'SCHOOL',
  University = 'UNIVERSITY'
}

export type DisciplineWithLessonsInput = {
  /** discipline id */
  discipline: Scalars['MOID']['input'];
  /** lessons of discipline */
  lessons: Array<Scalars['MOID']['input']>;
};

export type DisciplineWithLessonsOutput = {
  __typename?: 'DisciplineWithLessonsOutput';
  /** discipline */
  discipline: DisciplineOutput;
  /** lessons of discipline */
  lessons: Array<LessonOutput>;
  /** status of exam submission */
  status?: Maybe<ExamSubmissionStatus>;
};

export type DissertationInput = {
  part: DissertationPart;
  proposition: Scalars['String']['input'];
  subPart?: InputMaybe<Scalars['String']['input']>;
  subjectId: Scalars['MOID']['input'];
};

export type DissertationOutput = {
  __typename?: 'DissertationOutput';
  conclusion?: Maybe<ConclusionOutput>;
  developpement?: Maybe<DevelopmentOutput>;
  introduction?: Maybe<IntroductionOutput>;
};

export enum DissertationPart {
  Conclusion = 'CONCLUSION',
  Development = 'DEVELOPMENT',
  Introduction = 'INTRODUCTION'
}

export type DuplicateExamGenerationConfigInput = {
  /** end date */
  endDate: Scalars['DateTime']['input'];
  /** start date */
  startDate: Scalars['DateTime']['input'];
};

export enum EducatorType {
  Other = 'OTHER',
  Professional = 'PROFESSIONAL',
  Secondary = 'SECONDARY',
  University = 'UNIVERSITY'
}

export type EmailLoginInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type EvaluateQuizzInput = {
  classId?: InputMaybe<Scalars['MOID']['input']>;
  correctAnswers: Scalars['Float']['input'];
  questions?: InputMaybe<Array<AttemptQuestionInput>>;
  score: Scalars['Float']['input'];
  sectionId: Scalars['MOID']['input'];
};

export type EvaluationResultOutput = {
  __typename?: 'EvaluationResultOutput';
  earnedBadges?: Maybe<Array<BadgeOutput>>;
  globalRanking?: Maybe<Scalars['Int']['output']>;
  isBlocked: Scalars['Boolean']['output'];
  points?: Maybe<Scalars['Int']['output']>;
  remainingAttempts: Scalars['Int']['output'];
  remainingTimeInMinutes?: Maybe<Scalars['Int']['output']>;
  schoolRanking?: Maybe<Scalars['Int']['output']>;
};

export type ExamConfigInput = {
  /** classes of exam blanc */
  classes: Array<Scalars['MOID']['input']>;
  /** description of exam blanc */
  description: Scalars['String']['input'];
  /** disciplines of exam blanc */
  disciplinesWithLessons: Array<DisciplineWithLessonsInput>;
  /** duration in minutes of exam blanc */
  durationInMinutes?: InputMaybe<Scalars['Float']['input']>;
  /** end date of exam blanc */
  endDate: Scalars['DateTime']['input'];
  /** gift giving date of exam blanc */
  giftGivingDate: Scalars['DateTime']['input'];
  /** gifts of exam blanc */
  gifts?: Array<Scalars['MOID']['input']>;
  /** is enabled of exam blanc */
  isEnabled: Scalars['Boolean']['input'];
  /** name of exam blanc */
  name: Scalars['String']['input'];
  /** points to earn of exam blanc */
  pointsToEarn: Scalars['Float']['input'];
  /** result date of exam blanc */
  resultDate: Scalars['DateTime']['input'];
  /** school id of exam blanc */
  schoolId?: InputMaybe<Scalars['MOID']['input']>;
  /** series of exam blanc */
  series: Array<Scalars['MOID']['input']>;
  /** start date of exam blanc */
  startDate: Scalars['DateTime']['input'];
  /** title of exam blanc */
  title: Scalars['String']['input'];
};

export type ExamConfigOutput = {
  __typename?: 'ExamConfigOutput';
  _id: Scalars['MOID']['output'];
  /** classes of exam blanc */
  classes: Array<ClassOutput>;
  /** description of exam blanc */
  description: Scalars['String']['output'];
  /** disciplines of exam blanc */
  disciplinesWithLessons: Array<DisciplineWithLessonsOutput>;
  /** duration in minutes of exam blanc */
  durationInMinutes?: Maybe<Scalars['Float']['output']>;
  /** end date of exam blanc */
  endDate: Scalars['DateTime']['output'];
  /** gift giving date of exam blanc */
  giftGivingDate: Scalars['DateTime']['output'];
  /** gifts of exam blanc */
  gifts: Array<GiftOutput>;
  /** is enabled of exam blanc */
  isEnabled: Scalars['Boolean']['output'];
  /** name of exam blanc */
  name: Scalars['String']['output'];
  /** points to earn of exam blanc */
  pointsToEarn: Scalars['Float']['output'];
  /** result date of exam blanc */
  resultDate: Scalars['DateTime']['output'];
  /** school of exam blanc */
  school?: Maybe<SchoolOutput>;
  /** school id of exam blanc */
  schoolId?: Maybe<Scalars['MOID']['output']>;
  /** series of exam blanc */
  series: Array<SerieOutput>;
  /** start date of exam blanc */
  startDate: Scalars['DateTime']['output'];
  /** title of exam blanc */
  title: Scalars['String']['output'];
};

export type ExamCounterOutput = {
  __typename?: 'ExamCounterOutput';
  disciplines: Array<ExamDisciplineCounterOutput>;
  year: Scalars['String']['output'];
};

export type ExamDisciplineCounterOutput = {
  __typename?: 'ExamDisciplineCounterOutput';
  count: Scalars['Int']['output'];
  discipline: DisciplineOutput;
};

export type ExamDisciplineOutput = {
  __typename?: 'ExamDisciplineOutput';
  discipline: DisciplineOutput;
  exams: Array<ExamOutput>;
};

export type ExamExerciseOutput = {
  __typename?: 'ExamExerciseOutput';
  _id?: Maybe<Scalars['MOID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discipline?: Maybe<DisciplineOutput>;
  duration?: Maybe<Scalars['String']['output']>;
  lesson?: Maybe<LessonOutput>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Float']['output']>;
  questions?: Maybe<Array<QuestionOutput>>;
  series?: Maybe<Array<SerieOutput>>;
};

export type ExamFilteredOutput = {
  __typename?: 'ExamFilteredOutput';
  country?: Maybe<Scalars['String']['output']>;
  disciplines?: Maybe<Array<ExamDisciplineOutput>>;
  year?: Maybe<Scalars['String']['output']>;
};

export type ExamGenerationConfig = {
  __typename?: 'ExamGenerationConfig';
  _id?: Maybe<Scalars['MOID']['output']>;
  classIds: Array<Scalars['MOID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  difficultyLevel: DifficultyLevel;
  durationInMinutes: Scalars['String']['output'];
  endDate: Scalars['DateTime']['output'];
  generationType: Array<ExamGenerationType>;
  isDeleted: Scalars['Boolean']['output'];
  language: Language;
  /** lessons of discipline */
  lessonIds: Array<Scalars['MOID']['output']>;
  /** lessons of discipline */
  lessons: Array<LessonOutput>;
  name: Scalars['String']['output'];
  /** questions of discipline */
  questionIds: Array<Scalars['MOID']['output']>;
  questionTypes: QuestionType;
  /** questions of discipline */
  questions: Array<QuestionOutput>;
  questionsCount: Scalars['Float']['output'];
  startDate: Scalars['DateTime']['output'];
  status: ExamGenerationConfigStatus;
};

export type ExamGenerationConfigInput = {
  /** classes of exam generation config */
  classIds: Array<Scalars['MOID']['input']>;
  /** description of exam generation config */
  description?: InputMaybe<Scalars['String']['input']>;
  difficultyLevel: DifficultyLevel;
  /** duration in minutes of exam generation config */
  durationInMinutes: Scalars['String']['input'];
  endDate: Scalars['DateTime']['input'];
  /** generation type of exam generation config */
  generationType?: InputMaybe<ExamGenerationType>;
  language: Language;
  /** lessons of discipline */
  lessonIds?: InputMaybe<Array<Scalars['MOID']['input']>>;
  /** name of exam generation config */
  name: Scalars['String']['input'];
  questionIds?: InputMaybe<Array<Scalars['MOID']['input']>>;
  questionTypes?: InputMaybe<Array<QuestionType>>;
  questionsCount?: InputMaybe<Scalars['Float']['input']>;
  startDate: Scalars['DateTime']['input'];
};

export type ExamGenerationConfigQuery = {
  classId: Scalars['MOID']['input'];
  type?: InputMaybe<QuestionType>;
};

/** Exam generation config status */
export enum ExamGenerationConfigStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Pending = 'PENDING',
  Started = 'STARTED'
}

export type ExamGenerationQuestion = {
  __typename?: 'ExamGenerationQuestion';
  /** is correct */
  isCorrect?: Maybe<Scalars['Boolean']['output']>;
  /** question */
  question: QuestionOutput;
  /** question id */
  questionId: Scalars['MOID']['output'];
  /** user response */
  userResponse?: Maybe<Scalars['String']['output']>;
};

export type ExamGenerationSubmission = {
  __typename?: 'ExamGenerationSubmission';
  /** id */
  _id?: Maybe<Scalars['MOID']['output']>;
  /** class id */
  classId: Scalars['MOID']['output'];
  /** class */
  classInfo: ClassOutput;
  /** duration in minutes */
  durationInMinutes?: Maybe<Scalars['String']['output']>;
  /** exam generation config */
  examGenerationConfig: ExamGenerationConfig;
  /** exam generation config id */
  examGenerationConfigId: Scalars['MOID']['output'];
  /** exam generation questions */
  examGenerationQuestions: Array<ExamGenerationQuestion>;
  /** score */
  score: Scalars['Float']['output'];
  /** score in percentage */
  scoreInPercentage: Scalars['Float']['output'];
  /** exam generation config */
  status: ExamSubmissionStatus;
  /** user */
  student: StudentByClassOutput;
  /** user id */
  userId?: Maybe<Scalars['MOID']['output']>;
};

export type ExamGenerationSubmissionByStudentInput = {
  /** class id */
  classId: Scalars['MOID']['input'];
  /** exam generation config id */
  examGenerationConfigId: Scalars['MOID']['input'];
  /** user id */
  userId?: InputMaybe<Scalars['MOID']['input']>;
};

export type ExamGenerationSubmissionInput = {
  /** class id */
  classId: Scalars['MOID']['input'];
  /** duration in minutes */
  durationInMinutes?: InputMaybe<Scalars['String']['input']>;
  /** exam generation config id */
  examGenerationConfigId: Scalars['MOID']['input'];
  /** exam generation questions */
  examGenerationQuestions: Array<ExamQuestionInput>;
  /** user id */
  userId: Scalars['MOID']['input'];
};

/** Exam generation type */
export enum ExamGenerationType {
  FromIa = 'FROM_IA',
  FromLesson = 'FROM_LESSON',
  Manual = 'MANUAL'
}

export type ExamInput = {
  content: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  discipline: Scalars['MOID']['input'];
  name: Scalars['String']['input'];
  year: Scalars['String']['input'];
};

export type ExamOutput = {
  __typename?: 'ExamOutput';
  _id: Scalars['MOID']['output'];
  content: Scalars['String']['output'];
  discipline: DisciplineOutput;
  disciplines: Array<DisciplineOutput>;
  name: Scalars['String']['output'];
  year: Scalars['String']['output'];
};

export type ExamQuery = {
  country?: InputMaybe<Scalars['String']['input']>;
  disciplines?: InputMaybe<Array<Scalars['MOID']['input']>>;
  /** Limit is not required but has a default value */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Page is not required but has a default value */
  page?: InputMaybe<Scalars['Int']['input']>;
  years?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ExamQuestionInput = {
  /** is correct */
  isCorrect?: InputMaybe<Scalars['Boolean']['input']>;
  /** question id */
  question: Scalars['MOID']['input'];
  /** user response */
  userResponse?: InputMaybe<Scalars['String']['input']>;
};

export type ExamQuestionOutput = {
  __typename?: 'ExamQuestionOutput';
  /** is correct */
  isCorrect?: Maybe<Scalars['Boolean']['output']>;
  /** question */
  question: QuestionOutput;
  /** user response */
  userResponse?: Maybe<Scalars['String']['output']>;
};

export enum ExamResultGradingScale {
  Excellent = 'EXCELLENT',
  FairlyGood = 'FAIRLY_GOOD',
  Good = 'GOOD',
  Passable = 'PASSABLE',
  VeryGood = 'VERY_GOOD'
}

export type ExamResultOutput = {
  __typename?: 'ExamResultOutput';
  _id: Scalars['MOID']['output'];
  examConfig: ExamConfigOutput;
  globalScore: Scalars['Float']['output'];
  mention?: Maybe<ExamResultGradingScale>;
  points?: Maybe<Scalars['Float']['output']>;
  ranking?: Maybe<Scalars['Int']['output']>;
  scoreByDiscipline: Array<ScoreByDisciplineOutput>;
  user?: Maybe<UserOutput>;
};

export type ExamResultQuery = {
  examConfigId: Scalars['MOID']['input'];
  userId?: InputMaybe<Scalars['MOID']['input']>;
};

export type ExamSubmissionInput = {
  /** discipline id */
  discipline: Scalars['MOID']['input'];
  /** exam config id */
  examConfig: Scalars['MOID']['input'];
  /** exam questions */
  examQuestions: Array<ExamQuestionInput>;
  /** global duration */
  globalDuration?: InputMaybe<Scalars['String']['input']>;
};

export type ExamSubmissionOutput = {
  __typename?: 'ExamSubmissionOutput';
  _id: Scalars['MOID']['output'];
  /** discipline */
  discipline: DisciplineOutput;
  /** duration */
  duration?: Maybe<Scalars['String']['output']>;
  /** exam config id */
  examConfig: ExamConfigOutput;
  /** exam questions */
  examQuestions: Array<ExamQuestionOutput>;
  /** global duration */
  globalDuration?: Maybe<Scalars['String']['output']>;
  /** status */
  status: ExamSubmissionStatus;
};

export type ExamSubmissionQuery = {
  disciplineId: Scalars['MOID']['input'];
  examConfigId: Scalars['MOID']['input'];
};

export enum ExamSubmissionStatus {
  Initiated = 'INITIATED',
  NotStarted = 'NOT_STARTED',
  Submitted = 'SUBMITTED'
}

export type ExamTestInput = {
  /** discipline id */
  disciplineId: Scalars['MOID']['input'];
  /** exam config id */
  examConfigId: Scalars['MOID']['input'];
};

export type ExerciseInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  discipline?: InputMaybe<Scalars['MOID']['input']>;
  duration: Scalars['String']['input'];
  lesson?: InputMaybe<Scalars['MOID']['input']>;
  name: Scalars['String']['input'];
  position: Scalars['Float']['input'];
  questions?: InputMaybe<Array<QuestionInput>>;
  series?: InputMaybe<Array<Scalars['MOID']['input']>>;
};

export type ExerciseOutput = {
  __typename?: 'ExerciseOutput';
  _id: Scalars['MOID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  discipline?: Maybe<DisciplineOutput>;
  duration: Scalars['String']['output'];
  lesson?: Maybe<LessonOutput>;
  name: Scalars['String']['output'];
  position: Scalars['Float']['output'];
  questions: Array<QuestionOutput>;
  series?: Maybe<Array<SerieOutput>>;
};

export type ExerciseUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  discipline?: InputMaybe<Scalars['MOID']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  lesson?: InputMaybe<Scalars['MOID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
  questions?: InputMaybe<Array<QuestionInput>>;
  series?: InputMaybe<Array<Scalars['MOID']['input']>>;
};

export type Faq = {
  __typename?: 'Faq';
  _id: Scalars['MOID']['output'];
  answer: Scalars['String']['output'];
  category: FaqCategory;
  isPublished: Scalars['Boolean']['output'];
  question: Scalars['String']['output'];
};

export type FaqCategory = {
  __typename?: 'FaqCategory';
  _id: Scalars['MOID']['output'];
  name: Scalars['String']['output'];
};

export type FaqCategoryInput = {
  name: Scalars['String']['input'];
};

export type FaqInput = {
  answer: Scalars['String']['input'];
  category: Scalars['MOID']['input'];
  isPublished: Scalars['Boolean']['input'];
  question: Scalars['String']['input'];
};

export type FeedbackInput = {
  category?: InputMaybe<FeedbackType>;
  feedbacks?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FeedbackOutput = {
  __typename?: 'FeedbackOutput';
  _id: Scalars['MOID']['output'];
  category: FeedbackType;
  feedbacks: Array<Scalars['String']['output']>;
};

export type FeedbackQuery = {
  category?: InputMaybe<FeedbackType>;
};

export enum FeedbackType {
  AudioFeedback = 'AUDIO_FEEDBACK',
  ChapterGenerator = 'CHAPTER_GENERATOR',
  EvaluationStrategy = 'EVALUATION_STRATEGY',
  FinalExamGenerator = 'FINAL_EXAM_GENERATOR',
  FlashcardGenerator = 'FLASHCARD_GENERATOR',
  FullModuleGenerator = 'FULL_MODULE_GENERATOR',
  GlossaryGenerator = 'GLOSSARY_GENERATOR',
  ModuleSkeletonGenerator = 'MODULE_SKELETON_GENERATOR',
  QuizGenerator = 'QUIZ_GENERATOR',
  SingleQuizGenerator = 'SINGLE_QUIZ_GENERATOR',
  SummaryFeedback = 'SUMMARY_FEEDBACK'
}

export type FilteredUserOutput = {
  __typename?: 'FilteredUserOutput';
  _id?: Maybe<Scalars['MOID']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type FinancialAnalytic = {
  __typename?: 'FinancialAnalytic';
  conversionMetrics: ConversionMetrics;
  premiumMetrics: PremiumMetrics;
  resubscriptionMetrics: ResubscriptionMetrics;
  revenueTrendChart: Array<RevenueTrendPoint>;
  salesDistribution: SalesDistribution;
  subscriptionRevenues: SubscriptionRevenues;
  totalGrantsAmount: Scalars['Float']['output'];
  totalTransactionAmount: Scalars['Float']['output'];
};

export type FinancialAnalyticOutput = {
  __typename?: 'FinancialAnalyticOutput';
  financialAnalytic: FinancialAnalytic;
  userDistribution: UserDistribution;
};

export type Flashcard = {
  __typename?: 'Flashcard';
  _id: Scalars['MOID']['output'];
  back?: Maybe<FlashcardContent>;
  front: FlashcardContent;
  language: Language;
  lesson: LessonOutput;
  lessonId: Scalars['MOID']['output'];
  tags: Array<Scalars['String']['output']>;
};

export type FlashcardContent = {
  __typename?: 'FlashcardContent';
  html: Scalars['String']['output'];
  mediaContent?: Maybe<MediaContentOutput>;
  text: Scalars['String']['output'];
};

export type FlashcardContentInput = {
  html: Scalars['String']['input'];
  mediaContent?: InputMaybe<MediaContentInput>;
  text: Scalars['String']['input'];
};

export type FlashcardInput = {
  back?: InputMaybe<FlashcardContentInput>;
  front: FlashcardContentInput;
  language?: InputMaybe<Language>;
  lessonId: Scalars['MOID']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FlashcardQueryInput = {
  lessonId: Scalars['MOID']['input'];
};

export type FlashcardUpsertInput = {
  back?: InputMaybe<FlashcardContentInput>;
  front: FlashcardContentInput;
  id?: InputMaybe<Scalars['MOID']['input']>;
  language?: InputMaybe<Language>;
  lessonId: Scalars['MOID']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FlashcardUpsertOutput = {
  __typename?: 'FlashcardUpsertOutput';
  flashcardsUpserted: Scalars['Int']['output'];
  textError?: Maybe<Scalars['String']['output']>;
};

export type ForgotStudioPasswordInput = {
  email: Scalars['String']['input'];
};

export type GamificationHistory = {
  __typename?: 'GamificationHistory';
  /** Example field (placeholder) */
  exampleField: Scalars['Int']['output'];
};

export type GamificationInput = {
  points: Scalars['Int']['input'];
  type: GamificationType;
};

export type GamificationOutput = {
  __typename?: 'GamificationOutput';
  _id: Scalars['MOID']['output'];
  points: Scalars['Int']['output'];
  type: GamificationType;
};

export type GamificationQuery = {
  type?: InputMaybe<GamificationType>;
};

export enum GamificationType {
  Sponsorship = 'SPONSORSHIP'
}

export enum Gender {
  F = 'F',
  M = 'M'
}

export type GenderStat = {
  __typename?: 'GenderStat';
  clicks: Scalars['Float']['output'];
  gender: Scalars['String']['output'];
  views: Scalars['Float']['output'];
};

export type GenerateAudioInput = {
  htmlContent?: InputMaybe<Scalars['String']['input']>;
  lessonId: Scalars['MOID']['input'];
  schoolId?: InputMaybe<Scalars['MOID']['input']>;
  targetVoice?: TargetVoice;
};

export type GenerateContentInput = {
  audio?: InputMaybe<Scalars['String']['input']>;
  lessonId: Scalars['MOID']['input'];
  module: GenerateReadyModuleInput;
  summary?: InputMaybe<GenerateReadySummaryInput>;
};

export type GenerateEvaluationQuestionsInput = {
  classId?: InputMaybe<Scalars['MOID']['input']>;
  lessonId: Scalars['MOID']['input'];
  type: GeneratedExamDraftType;
};

export type GenerateFlashcardsInput = {
  lessonId: Scalars['MOID']['input'];
  schoolId?: InputMaybe<Scalars['MOID']['input']>;
};

export type GenerateGlossariesInput = {
  lessonId: Scalars['MOID']['input'];
  schoolId?: InputMaybe<Scalars['MOID']['input']>;
};

export type GenerateModuleInput = {
  generateAssets?: Scalars['Boolean']['input'];
  lessonId: Scalars['MOID']['input'];
  schoolId?: InputMaybe<Scalars['MOID']['input']>;
};

export type GenerateModuleOutput = {
  __typename?: 'GenerateModuleOutput';
  sections: Array<GenerateSectionOutput>;
};

export type GenerateModuleSectionContentInput = {
  highlights: Array<HighlightContentInput>;
  quizz: Array<QuestionContentInput>;
  section: GenerateSectionContentInput;
};

export type GeneratePodcastInput = {
  lessonId: Scalars['MOID']['input'];
  schoolId?: InputMaybe<Scalars['MOID']['input']>;
};

export type GenerateReadyChapterInput = {
  content?: InputMaybe<ChapterContentInput>;
  lessonId: Scalars['MOID']['input'];
  mediaContent?: Array<MediaContentInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Float']['input'];
  question?: InputMaybe<QuestionInput>;
  sectionId: Scalars['MOID']['input'];
};

export type GenerateReadyFlashcardInput = {
  back?: InputMaybe<FlashcardContentInput>;
  chapterId?: InputMaybe<Scalars['MOID']['input']>;
  front: FlashcardContentInput;
  sectionId?: InputMaybe<Scalars['MOID']['input']>;
};

export type GenerateReadyModuleInput = {
  sections: Array<GenerateModuleSectionContentInput>;
};

export type GenerateReadySummaryInput = {
  content: SummaryContentInput;
};

export type GenerateSectionContentInput = {
  _id?: InputMaybe<Scalars['MOID']['input']>;
  audio?: InputMaybe<Scalars['String']['input']>;
  chapters?: Array<GenerateReadyChapterInput>;
  content: Array<ModuleContentInput>;
  flashcards?: Array<GenerateReadyFlashcardInput>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  lessonsId: Scalars['String']['input'];
  maxPoint?: InputMaybe<Scalars['Float']['input']>;
  objectives?: InputMaybe<Array<Scalars['String']['input']>>;
  position: Scalars['Float']['input'];
  status?: InputMaybe<ProgressionStatus>;
  title: Scalars['String']['input'];
};

export type GenerateSectionOutput = {
  __typename?: 'GenerateSectionOutput';
  _id?: Maybe<Scalars['MOID']['output']>;
  highlights: Array<HighlightOutput>;
  quizz: Array<QuestionOutput>;
  section: SectionOutput;
};

export type GenerateSummaryInput = {
  lessonId: Scalars['MOID']['input'];
  schoolId?: InputMaybe<Scalars['MOID']['input']>;
};

export type GenerateSummaryOutput = {
  __typename?: 'GenerateSummaryOutput';
  content: SummaryContentOutput;
};

export enum GeneratedExamDraftType {
  DisciplineExam = 'DISCIPLINE_EXAM',
  LessonExam = 'LESSON_EXAM',
  SectionExam = 'SECTION_EXAM'
}

export type GetLessonProgressionByClassPaginatedInput = {
  /** Class for the progression */
  classId: Scalars['MOID']['input'];
  /** Filter by struggling state */
  difficulty?: InputMaybe<LessonProgressionDifficultyFilter>;
  /** Lesson for the progression */
  lessonId: Scalars['MOID']['input'];
  /** Limit is not required but has a default value */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Page is not required but has a default value */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Search term for student full name */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter by computed lesson status */
  status?: InputMaybe<LessonProgressionStatusFilter>;
};

export type GetStudentDetailByClassInput = {
  classId: Scalars['MOID']['input'];
  username: Scalars['String']['input'];
};

export type GetStudentDetailByClassOutput = {
  __typename?: 'GetStudentDetailByClassOutput';
  _id?: Maybe<Scalars['MOID']['output']>;
  birthDate: Scalars['String']['output'];
  classRanking: Scalars['Int']['output'];
  disciplines: Array<GetStudentDetailsDisciplineByClass>;
  firstName: Scalars['String']['output'];
  gender?: Maybe<Gender>;
  lastName: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  points: Scalars['Int']['output'];
  progressions: Array<Progression>;
  subscriptionDate?: Maybe<Scalars['DateTime']['output']>;
};

export type GetStudentDetailsDisciplineByClass = {
  __typename?: 'GetStudentDetailsDisciplineByClass';
  completedLessons: Scalars['Int']['output'];
  discipline: DisciplineOutput;
  points: Scalars['Int']['output'];
  ranking: Scalars['Int']['output'];
  teacher?: Maybe<TeacherByClassOutput>;
  totalLessons: Scalars['Int']['output'];
};

export type GetStudentsByClassInput = {
  classId: Scalars['MOID']['input'];
  disciplineIds?: InputMaybe<Array<Scalars['MOID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: StudentSortBy;
};

export type GetStudentsByClassPaginatedInput = {
  classId: Scalars['MOID']['input'];
  disciplineIds?: InputMaybe<Array<Scalars['MOID']['input']>>;
  /** Limit is not required but has a default value */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Page is not required but has a default value */
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: StudentSortBy;
  statuses?: InputMaybe<Array<ClassRessoucesStudentStatus>>;
};

export type GiftOutput = {
  __typename?: 'GiftOutput';
  _id: Scalars['MOID']['output'];
  /** image of gift */
  image: Scalars['String']['output'];
  /** is private gift */
  isPrivate: Scalars['Boolean']['output'];
  /** name of gift */
  name: Scalars['String']['output'];
  /** points of gift */
  points: Scalars['Float']['output'];
  /** ranking of gift */
  ranking: Scalars['String']['output'];
  /** status of gift */
  status: Scalars['String']['output'];
};

export type GiftRequest = {
  __typename?: 'GiftRequest';
  /** Example field (placeholder) */
  exampleField: Scalars['Int']['output'];
};

/** Gift status */
export enum GiftStatus {
  Available = 'AVAILABLE',
  NotAvailable = 'NOT_AVAILABLE'
}

export type GiftsToExamConfigInput = {
  /** exam config id */
  examConfigId: Scalars['MOID']['input'];
  /** gifts of exam config */
  gifts?: InputMaybe<Array<Scalars['MOID']['input']>>;
  /** new gifts of exam config */
  newGifts?: InputMaybe<Array<NewGiftInput>>;
};

export type Glossary = {
  __typename?: 'Glossary';
  _id: Scalars['MOID']['output'];
  definition: GlossaryDefinition;
  language: Language;
  lesson: LessonOutput;
  lessonId: Scalars['MOID']['output'];
  mediaContent: MediaContentOutput;
  tags: Array<Scalars['String']['output']>;
  teacher: UserOutput;
  teacherId: Scalars['MOID']['output'];
  term: Scalars['String']['output'];
};

export type GlossaryDefinition = {
  __typename?: 'GlossaryDefinition';
  html: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type GlossaryDefinitionInput = {
  html: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type GlossaryInput = {
  definition: GlossaryDefinitionInput;
  language?: InputMaybe<Language>;
  lessonId: Scalars['MOID']['input'];
  mediaContent?: InputMaybe<MediaContentInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  teacherId: Scalars['MOID']['input'];
  term: Scalars['String']['input'];
};

export type GlossaryQueryInput = {
  lessonId: Scalars['MOID']['input'];
};

export type GlossaryUpsertInput = {
  definition: GlossaryDefinitionInput;
  id?: InputMaybe<Scalars['MOID']['input']>;
  language?: InputMaybe<Language>;
  lessonId: Scalars['MOID']['input'];
  mediaContent?: InputMaybe<MediaContentInput>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  teacherId: Scalars['MOID']['input'];
  term: Scalars['String']['input'];
};

export type GlossaryUpsertOutput = {
  __typename?: 'GlossaryUpsertOutput';
  glossariesUpserted: Scalars['Int']['output'];
  textError?: Maybe<Scalars['String']['output']>;
};

export type GroupedLessonsOutput = {
  __typename?: 'GroupedLessonsOutput';
  discipline: DisciplineOutput;
  lessons: Array<LessonOutput>;
  points?: Maybe<Scalars['Int']['output']>;
  teacher?: Maybe<TeacherByClassOutput>;
};

export type HandleJoinRequestInput = {
  accept: Scalars['Boolean']['input'];
  classId: Scalars['MOID']['input'];
  students: Array<Scalars['String']['input']>;
};

export type HighLightUpdate = {
  _id?: InputMaybe<Scalars['MOID']['input']>;
  definition?: InputMaybe<Definition>;
  slug?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type HighlightContentInput = {
  _id?: InputMaybe<Scalars['MOID']['input']>;
  definition: DefinitionContentInput;
  slug: Scalars['String']['input'];
  term: Scalars['String']['input'];
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type HighlightInput = {
  _id?: InputMaybe<Scalars['MOID']['input']>;
  definition: Definition;
  term: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
};

export type HighlightOutput = {
  __typename?: 'HighlightOutput';
  _id: Scalars['MOID']['output'];
  definition: DefinitionOutput;
  slug: Scalars['String']['output'];
  term: Scalars['String']['output'];
  uuid?: Maybe<Scalars['String']['output']>;
};

export type HighlightQuery = {
  /** Limit is not required but has a default value */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Page is not required but has a default value */
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type IaSubscriptionInput = {
  concernBy?: InputMaybe<Array<ParentRole>>;
  creditCount: Scalars['Int']['input'];
  currency: Scalars['String']['input'];
  description: Scalars['String']['input'];
  pricing: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type IaSubscriptions = {
  __typename?: 'IaSubscriptions';
  _id: Scalars['MOID']['output'];
  concernBy?: Maybe<Array<ParentRole>>;
  countries: Array<Scalars['String']['output']>;
  creditCount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  description: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  pricing: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type InitiateIaCreditCheckoutInput = {
  iaSubscriptionId: Scalars['MOID']['input'];
  pspName: PaymentWay;
  schoolId?: InputMaybe<Scalars['MOID']['input']>;
};

export type InitiatePublicClassCheckoutInput = {
  contact: Scalars['String']['input'];
  paymentMethod: PaymentWay;
  slug: Scalars['String']['input'];
};

export type IntroductionOutput = {
  __typename?: 'IntroductionOutput';
  commentaire: Scalars['String']['output'];
  note: Scalars['Float']['output'];
};

export type InviteStudentToClassOutput = {
  __typename?: 'InviteStudentToClassOutput';
  message: Scalars['String']['output'];
  studentsAlreadyInvited: Array<Scalars['String']['output']>;
};

export enum Language {
  Ar = 'AR',
  De = 'DE',
  En = 'EN',
  Es = 'ES',
  Fr = 'FR',
  It = 'IT',
  Pt = 'PT',
  Ru = 'RU',
  Zh = 'ZH'
}

export type LessonAdminQuery = {
  belongToLesson?: InputMaybe<Scalars['MOID']['input']>;
  classes?: InputMaybe<Array<Scalars['MOID']['input']>>;
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  disciplines?: InputMaybe<Array<Scalars['MOID']['input']>>;
  isFrontPage?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  /** Limit is not required but has a default value */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Page is not required but has a default value */
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  series?: InputMaybe<Array<Scalars['MOID']['input']>>;
};

export type LessonConfigurationsInput = {
  maxDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LessonConfigurationsOutput = {
  __typename?: 'LessonConfigurationsOutput';
  maxDate?: Maybe<Scalars['DateTime']['output']>;
};

export type LessonGeneratedFromInput = {
  link: Scalars['String']['input'];
  type: LessonSource;
};

export type LessonGeneratedFromOutput = {
  __typename?: 'LessonGeneratedFromOutput';
  link: Scalars['String']['output'];
  type: LessonSource;
};

export type LessonGenerationHandlerOutput = {
  __typename?: 'LessonGenerationHandlerOutput';
  failedReason?: Maybe<Scalars['String']['output']>;
  status: LessonGenerationHandlerStatus;
  type: LessonGenerationHandlerType;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum LessonGenerationHandlerStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export enum LessonGenerationHandlerType {
  Audio = 'AUDIO',
  Flashcard = 'FLASHCARD',
  Glossary = 'GLOSSARY',
  Podcast = 'PODCAST',
  Section = 'SECTION',
  Summary = 'SUMMARY'
}

export type LessonInput = {
  audioResumeDuration?: InputMaybe<Scalars['String']['input']>;
  audioShortcut?: InputMaybe<Scalars['String']['input']>;
  belongToLesson?: InputMaybe<Scalars['MOID']['input']>;
  classes?: InputMaybe<Array<Scalars['MOID']['input']>>;
  configurations?: InputMaybe<LessonConfigurationsInput>;
  content?: InputMaybe<Scalars['String']['input']>;
  contentId?: InputMaybe<Scalars['String']['input']>;
  contentNamespace?: InputMaybe<Scalars['String']['input']>;
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  discipline?: InputMaybe<Scalars['MOID']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  generatedFrom?: InputMaybe<LessonGeneratedFromInput>;
  idAskYourPdf?: InputMaybe<Scalars['String']['input']>;
  image: Scalars['String']['input'];
  isFrontPage?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  longContent?: InputMaybe<ContentInput>;
  mediaContent?: Array<MediaContentInput>;
  name: Scalars['String']['input'];
  pdfLesson?: InputMaybe<Scalars['String']['input']>;
  podcast?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
  preview?: InputMaybe<Scalars['String']['input']>;
  school?: InputMaybe<Scalars['MOID']['input']>;
  series?: InputMaybe<Array<Scalars['MOID']['input']>>;
  sourceLanguage?: InputMaybe<Scalars['String']['input']>;
  student?: InputMaybe<Scalars['MOID']['input']>;
  summary?: InputMaybe<ContentInput>;
  targetLanguage?: InputMaybe<Scalars['String']['input']>;
  teacher?: InputMaybe<Scalars['MOID']['input']>;
};

export type LessonInputUpdate = {
  audioResumeDuration?: InputMaybe<Scalars['String']['input']>;
  audioShortcut?: InputMaybe<Scalars['String']['input']>;
  belongToLesson?: InputMaybe<Scalars['MOID']['input']>;
  classes?: InputMaybe<Array<Scalars['MOID']['input']>>;
  configurations?: InputMaybe<LessonConfigurationsInput>;
  content?: InputMaybe<Scalars['String']['input']>;
  contentId?: InputMaybe<Scalars['String']['input']>;
  contentNamespace?: InputMaybe<Scalars['String']['input']>;
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  discipline?: InputMaybe<Scalars['MOID']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  generatedFrom?: InputMaybe<LessonGeneratedFromInput>;
  idAskYourPdf?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  isFrontPage?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  longContent?: InputMaybe<ContentInput>;
  mediaContent?: InputMaybe<Array<MediaContentInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  pdfLesson?: InputMaybe<Scalars['String']['input']>;
  podcast?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Float']['input']>;
  preview?: InputMaybe<Scalars['String']['input']>;
  school?: InputMaybe<Scalars['MOID']['input']>;
  series?: InputMaybe<Array<Scalars['MOID']['input']>>;
  sourceLanguage?: InputMaybe<Scalars['String']['input']>;
  student?: InputMaybe<Scalars['MOID']['input']>;
  summary?: InputMaybe<ContentInput>;
  targetLanguage?: InputMaybe<Scalars['String']['input']>;
  teacher?: InputMaybe<Scalars['MOID']['input']>;
};

export type LessonOutput = {
  __typename?: 'LessonOutput';
  _id: Scalars['MOID']['output'];
  alreadyPurchased: Scalars['Boolean']['output'];
  audioResumeDuration?: Maybe<Scalars['String']['output']>;
  audioShortcut?: Maybe<Scalars['String']['output']>;
  belongToLesson?: Maybe<LessonOutput>;
  classes?: Maybe<Array<ClassOutput>>;
  configurations?: Maybe<LessonConfigurationsOutput>;
  content?: Maybe<Scalars['String']['output']>;
  contentId?: Maybe<Scalars['String']['output']>;
  contentNamespace?: Maybe<Scalars['String']['output']>;
  countries?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  discipline?: Maybe<DisciplineOutput>;
  duration?: Maybe<Scalars['String']['output']>;
  flashcards?: Maybe<Array<Flashcard>>;
  generatedFrom?: Maybe<LessonGeneratedFromOutput>;
  generationHandler?: Maybe<Array<LessonGenerationHandlerOutput>>;
  generationObjectHandler?: Maybe<Scalars['GraphQLObject']['output']>;
  glossaries?: Maybe<Array<Glossary>>;
  idAskYourPdf?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use mediaContent instead */
  image?: Maybe<Scalars['String']['output']>;
  isChatbotEnabled?: Maybe<Scalars['Boolean']['output']>;
  isFree: Scalars['Boolean']['output'];
  isFromStudio: Scalars['Boolean']['output'];
  isFrontPage?: Maybe<Scalars['Boolean']['output']>;
  isPublished?: Maybe<Scalars['Boolean']['output']>;
  longContent?: Maybe<Content>;
  mediaContent?: Maybe<Array<MediaContentOutput>>;
  name: Scalars['String']['output'];
  pdfLesson?: Maybe<Scalars['String']['output']>;
  podcast?: Maybe<Scalars['String']['output']>;
  points?: Maybe<Scalars['Int']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  preview?: Maybe<Scalars['String']['output']>;
  progression?: Maybe<ProgressionOutput>;
  progressionsCount?: Maybe<Scalars['Int']['output']>;
  rateCompletion?: Maybe<Scalars['GraphQLObject']['output']>;
  school?: Maybe<SchoolOutput>;
  series?: Maybe<Array<SerieOutput>>;
  subscriptionInfo?: Maybe<SubscriptionPackagesOutput>;
  summary?: Maybe<Content>;
  teacher?: Maybe<UserOutput>;
  unlocked?: Maybe<Scalars['Boolean']['output']>;
};

export type LessonOutputPagination = {
  __typename?: 'LessonOutputPagination';
  currentPage: Scalars['Int']['output'];
  data: Array<LessonOutput>;
  total: Scalars['Int']['output'];
};

export type LessonProgressionByClassStatsOutput = {
  __typename?: 'LessonProgressionByClassStatsOutput';
  averageScore: Scalars['Int']['output'];
  completionRate: Scalars['Int']['output'];
  strugglingStudents: Scalars['Int']['output'];
  totalStudents: Scalars['Int']['output'];
};

export enum LessonProgressionDifficultyFilter {
  NotStruggling = 'NOT_STRUGGLING',
  Struggling = 'STRUGGLING'
}

export enum LessonProgressionStatusFilter {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

export type LessonQuery = {
  belongToLesson?: InputMaybe<Scalars['MOID']['input']>;
  classes?: InputMaybe<Array<Scalars['MOID']['input']>>;
  country?: InputMaybe<Scalars['String']['input']>;
  disciplines?: InputMaybe<Array<Scalars['MOID']['input']>>;
  isFrontPage?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  /** Limit is not required but has a default value */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Page is not required but has a default value */
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  series?: InputMaybe<Array<Scalars['MOID']['input']>>;
  studentId?: InputMaybe<Scalars['MOID']['input']>;
};

export enum LessonSource {
  Audio = 'AUDIO',
  Pdf = 'PDF',
  Text = 'TEXT',
  Video = 'VIDEO',
  Website = 'WEBSITE',
  Youtube = 'YOUTUBE'
}

export type LessonTeacherSchoolQuery = {
  classes?: InputMaybe<Array<Scalars['MOID']['input']>>;
  disciplines?: InputMaybe<Array<Scalars['MOID']['input']>>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  /** Limit is not required but has a default value */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Page is not required but has a default value */
  page?: InputMaybe<Scalars['Int']['input']>;
  school?: InputMaybe<Scalars['MOID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  series?: InputMaybe<Array<Scalars['MOID']['input']>>;
};

export type LinkQueryInput = {
  assetId: Scalars['MOID']['input'];
  assetType: AssetType;
  linkType: Roles;
};

export type LiveSessionJoinOutput = {
  __typename?: 'LiveSessionJoinOutput';
  roomUrl: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type LiveSessionOutput = {
  __typename?: 'LiveSessionOutput';
  _id: Scalars['String']['output'];
  classId: Scalars['String']['output'];
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  provider: Scalars['String']['output'];
  recordingId?: Maybe<Scalars['String']['output']>;
  recordingStatus: MediaStatus;
  replayUrl?: Maybe<Scalars['String']['output']>;
  roomName: Scalars['String']['output'];
  roomUrl: Scalars['String']['output'];
  startedAt: Scalars['DateTime']['output'];
  status: LiveSessionStatus;
  summary?: Maybe<Content>;
  summaryStatus?: Maybe<MediaStatus>;
  teacherId: Scalars['String']['output'];
  transcriptId?: Maybe<Scalars['String']['output']>;
  transcriptStatus: MediaStatus;
  transcriptUrl?: Maybe<Scalars['String']['output']>;
};

export enum LiveSessionStatus {
  Ended = 'ENDED',
  Live = 'LIVE'
}

export type LoginInput = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type MediaAccessLinkOutput = {
  __typename?: 'MediaAccessLinkOutput';
  url: Scalars['String']['output'];
};

export type MediaContentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  link: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: Array<Scalars['String']['input']>;
  type: MediaType;
};

export type MediaContentOutput = {
  __typename?: 'MediaContentOutput';
  description?: Maybe<Scalars['String']['output']>;
  link: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  type: MediaType;
};

export enum MediaStatus {
  Error = 'ERROR',
  None = 'NONE',
  Processing = 'PROCESSING',
  Ready = 'READY'
}

export enum MediaType {
  Audio = 'AUDIO',
  Image = 'IMAGE',
  Video = 'VIDEO',
  Youtube = 'YOUTUBE'
}

export type Module = {
  __typename?: 'Module';
  /** Example field (placeholder) */
  exampleField: Scalars['Int']['output'];
};

export type ModuleContentInput = {
  _id?: InputMaybe<Scalars['MOID']['input']>;
  html: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
  type: SectionType;
};

export type ModuleProgressionInput = {
  /** Quizz data for the module */
  attempts: AttemptsInput;
  classId?: InputMaybe<Scalars['MOID']['input']>;
  /** Score of the module */
  module_score: Scalars['Int']['input'];
  /** Section for the module progression */
  section: Scalars['MOID']['input'];
};

export type ModuleProgressionOutput = {
  __typename?: 'ModuleProgressionOutput';
  /** Quizz data for the module */
  attempts: Array<AttemptsOutput>;
  /** Last evaluation date */
  lastEvaluationDate?: Maybe<Scalars['DateTime']['output']>;
  /** Score of the module */
  module_score?: Maybe<Scalars['Int']['output']>;
  /** Section for the module progression */
  section: Scalars['MOID']['output'];
  sectionObject: SectionOutput;
  /** Status of the progression */
  status: ProgressionStatus;
};

export type MultipleQuestionsInput = {
  lesson: Scalars['MOID']['input'];
  questions: Array<QuestionInput>;
};

export type Mutation = {
  __typename?: 'Mutation';
  activateChatbotForLesson: Scalars['Boolean']['output'];
  addGiftsToExamConfig: Scalars['Boolean']['output'];
  askToLesson: ChatbotResponseOutput;
  cancelGenerateSection: Scalars['Boolean']['output'];
  checkAccessCode: Array<ClassOutput>;
  createAclAsset: Scalars['Boolean']['output'];
  createAnnouncement: AnnoucementOutput;
  createAssetConfig: AssetConfig;
  createBac: BacOutput;
  createBadge: BadgeOutput;
  createCampaign: CampaignOutput;
  createCategory: CategoryOutput;
  createChapter: ChapterOutput;
  createChapterQuestion: ChapterOutput;
  createChariowClassMapping: ChariowClassMapping;
  createClass: ClassOutput;
  createClassSchool: ClassSchoolCreationOutput;
  createClassTeacher: ClassSchoolCreationOutput;
  createCompany: CompanyOutput;
  createConfiguration: Configuration;
  createConsumedCredit: ConsumedCreditsOutput;
  createCountry: CountriesOutput;
  createCoupon: CouponOutput;
  createDiscipline: DisciplineOutput;
  createExam: ExamOutput;
  createExamConfig: ExamConfigOutput;
  createExamGenerationConfig: ExamGenerationConfig;
  createExamSubmission: ExamSubmissionOutput;
  createExercise: ExerciseOutput;
  createFaq: Faq;
  createFaqCategory: FaqCategory;
  createFeedback: FeedbackOutput;
  createFlashcard: Flashcard;
  createGamification: GamificationOutput;
  createGift: GiftOutput;
  createGiftRequest: GiftRequest;
  createGlossary: Glossary;
  createHighlight: HighlightOutput;
  createIaSubscription: IaSubscriptions;
  createLesson: LessonOutput;
  createModule: Module;
  createMultipleQuestion: Scalars['Boolean']['output'];
  createMultipleQuestionsExamGenerationConfig: ExamGenerationConfig;
  createNotification: Notification;
  createObjective: ObjectiveOutput;
  createPayment: ChargeOutput;
  createProgression: Progression;
  createQuestion: QuestionOutput;
  createRegion: RegionOutput;
  createSchool: SchoolOutput;
  createSection: SectionOutput;
  createSeries: SerieOutput;
  createSociumIntegration: SociumIntegrationWithKeyOutput;
  createSubscriptionPackageByClass: SubscriptionPackagesOutput;
  createSubscriptionPackages: SubscriptionPackagesOutput;
  createTeacher: Scalars['Boolean']['output'];
  createTip: TipOutput;
  createTipsCategory: TipsCategoryOutput;
  createUser: AuthOutput;
  deleteAclAsset: Scalars['Boolean']['output'];
  deleteAdminSchoolFromSchool: Scalars['Boolean']['output'];
  deleteAdminsFromSchool: Scalars['Boolean']['output'];
  deleteAnnouncement: Scalars['Boolean']['output'];
  deleteAssetConfig: Scalars['Boolean']['output'];
  deleteCampaign: Scalars['Boolean']['output'];
  deleteChariowClassMapping: Scalars['Boolean']['output'];
  deleteCompany: Scalars['Boolean']['output'];
  deleteExamConfig: Scalars['Boolean']['output'];
  deleteExamGenerationConfig: Scalars['Boolean']['output'];
  deleteFaq: Scalars['Boolean']['output'];
  deleteFaqCategory: Scalars['Boolean']['output'];
  deleteGift: GiftOutput;
  deleteMultipleQuestionsForExamGenerationConfig: Scalars['Boolean']['output'];
  deleteTeacherFromSchool: Scalars['Boolean']['output'];
  deleteTeachersFromSchool: Scalars['Boolean']['output'];
  deleteUser: Scalars['Boolean']['output'];
  duplicateExamGenerationConfig: ExamGenerationConfig;
  endLiveSession: Scalars['Boolean']['output'];
  ensureClassLanding: ClassLandingAdminOutput;
  evaluateQuizz: EvaluationResultOutput;
  finalizeEvaluation: EvaluationResultOutput;
  forgotStudioPassword: Scalars['Boolean']['output'];
  generateAudio: Scalars['String']['output'];
  /** @deprecated Use generateEvaluationQuestions instead */
  generateEvaluation: Array<ExerciseOutput>;
  generateEvaluationQuestions: Array<QuestionOutput>;
  generateExamQuestions: Array<QuestionOutput>;
  generateExamTest: Array<ExamExerciseOutput>;
  generateFlashcards: Array<Flashcard>;
  generateGlossaries: Array<Glossary>;
  generateLiveSessionSummary: Scalars['Boolean']['output'];
  generateModuleQuizz: QuestionsModuleOutput;
  generateOtp: Scalars['Boolean']['output'];
  generatePaymentLink: Scalars['String']['output'];
  generatePodcast: Scalars['String']['output'];
  generateSections: GenerateModuleOutput;
  generateSummary: GenerateSummaryOutput;
  handleJoinRequest: Scalars['Boolean']['output'];
  initiateIaCreditCheckout: ChargeOutput;
  initiatePublicClassCheckout: ChargeOutput;
  inviteAdminSchool: Scalars['Boolean']['output'];
  inviteStudentToClass: InviteStudentToClassOutput;
  inviteTeacher: Scalars['Boolean']['output'];
  joinLiveSession: LiveSessionJoinOutput;
  joinPublicClass: Scalars['Boolean']['output'];
  launchGenerateAudioByQueue: Scalars['String']['output'];
  launchGenerateFlashcardsByQueue: Scalars['String']['output'];
  launchGenerateGlossariesByQueue: Scalars['String']['output'];
  launchGeneratePodcastByQueue: Scalars['String']['output'];
  launchGenerateQuizzByQueue: Scalars['String']['output'];
  launchGenerateSectionByQueue: Scalars['String']['output'];
  launchGenerateSummaryByQueue: Scalars['String']['output'];
  login: AuthOutput;
  logout: Scalars['Boolean']['output'];
  removeCategory: Scalars['Boolean']['output'];
  removeChapter: Scalars['Boolean']['output'];
  removeClass: Scalars['Boolean']['output'];
  removeConfiguration: Configuration;
  removeCountry: Scalars['Boolean']['output'];
  removeDiscipline: Scalars['Boolean']['output'];
  removeExam: Scalars['Boolean']['output'];
  removeExercise: Scalars['Boolean']['output'];
  removeFlashcard: Scalars['Boolean']['output'];
  removeGamification: Scalars['Boolean']['output'];
  removeGiftRequest: GiftRequest;
  removeGlossary: Scalars['Boolean']['output'];
  removeHighlight: Scalars['Boolean']['output'];
  removeLesson: Scalars['Boolean']['output'];
  removeModule: Module;
  removeNotification: Notification;
  removeObjective: Scalars['Boolean']['output'];
  removeProgression: Progression;
  removeQuestion: Scalars['Boolean']['output'];
  removeRegion: Scalars['Boolean']['output'];
  removeSchool: Scalars['Boolean']['output'];
  removeSection: Scalars['Boolean']['output'];
  removeSeries: Scalars['Boolean']['output'];
  removeStudentsFromClass: Scalars['Boolean']['output'];
  removeSubscriptionPackage: Scalars['Boolean']['output'];
  removeTip: Scalars['Boolean']['output'];
  removeTipsCategory: Scalars['Boolean']['output'];
  requestToJoinClass: Scalars['Boolean']['output'];
  resendActivationLink: Scalars['Boolean']['output'];
  resendJoinSchoolEmail: Scalars['Boolean']['output'];
  resetPassword: Scalars['Boolean']['output'];
  resetStudioPassword: Scalars['Boolean']['output'];
  retrySectionsGeneration: Scalars['String']['output'];
  rotateSociumIntegrationKey: SociumIntegrationWithKeyOutput;
  saveGeneratedContent: Scalars['String']['output'];
  saveSession: SessionOutput;
  saveTranscriptId: Scalars['Boolean']['output'];
  seenAnnouncementBy: Scalars['Boolean']['output'];
  setFrontPage: Scalars['Boolean']['output'];
  setSchoolFeatures: SchoolOutput;
  setSociumIntegrationStatus: SociumIntegrationOutput;
  startLiveSession: LiveSessionJoinOutput;
  submitDissertation?: Maybe<DissertationOutput>;
  submitExam: Scalars['Boolean']['output'];
  submitExamGeneration: Scalars['Boolean']['output'];
  teacherSchoolAdminLogin: AuthOutput;
  unlinkGiftsFromExamConfig: Scalars['Boolean']['output'];
  updateAnnouncement: Scalars['Boolean']['output'];
  updateAssetConfig: AssetConfig;
  updateCampaign: Scalars['Boolean']['output'];
  updateCampaignStat: Scalars['Boolean']['output'];
  updateCategory: Scalars['Boolean']['output'];
  updateChapter: Scalars['Boolean']['output'];
  updateChariowClassMapping: ChariowClassMapping;
  updateClass: Scalars['Boolean']['output'];
  updateClassLandingConfiguration: ClassLandingAdminOutput;
  updateClassLandingPresentation: Scalars['Boolean']['output'];
  updateClassLandingSlug: ClassLandingAdminOutput;
  updateClassSchool: ClassSchoolUpdateOutput;
  updateClassTeacher: Scalars['Boolean']['output'];
  updateConfiguration: Configuration;
  updateContent: Scalars['Boolean']['output'];
  updateCountry: Scalars['Boolean']['output'];
  updateCoupon: Scalars['Boolean']['output'];
  updateDiscipline: Scalars['Boolean']['output'];
  updateExam: Scalars['Boolean']['output'];
  updateExamConfig: Scalars['Boolean']['output'];
  updateExamGenerationConfig: Scalars['Boolean']['output'];
  updateExercise: ExerciseOutput;
  updateFaq: Scalars['Boolean']['output'];
  updateFaqCategory: Scalars['Boolean']['output'];
  updateFlashcard: Scalars['Boolean']['output'];
  updateGamification: Scalars['Boolean']['output'];
  updateGift: GiftOutput;
  updateGiftRequest: GiftRequest;
  updateGlossary: Scalars['Boolean']['output'];
  updateHighlight: Scalars['Boolean']['output'];
  updateLesson: Scalars['Boolean']['output'];
  updateModule: Module;
  updateModuleProgression: Progression;
  updateObjective: Scalars['Boolean']['output'];
  updatePassword: Scalars['Boolean']['output'];
  updateProgression: Progression;
  updateQuestion: Scalars['Boolean']['output'];
  updateRegion: RegionOutput;
  updateSchool: Scalars['Boolean']['output'];
  updateSchoolStatus: SchoolOutput;
  updateSection: Scalars['Boolean']['output'];
  updateSeries: Scalars['Boolean']['output'];
  updateSociumIntegration: SociumIntegrationOutput;
  updateSubscriptionPackage: SubscriptionPackagesOutput;
  updateTeacherCreditByClass: Scalars['Boolean']['output'];
  updateTip: Scalars['Boolean']['output'];
  updateTipsCategory: Scalars['Boolean']['output'];
  updateUser: Scalars['Boolean']['output'];
  updateUserSchool: Scalars['Boolean']['output'];
  upsertClassReminderCampaign: ClassReminderCampaignOutput;
  upsertMultipleChapters: ChapterUpsertOutput;
  upsertMultipleFlashcards: FlashcardUpsertOutput;
  upsertMultipleGlossaries: GlossaryUpsertOutput;
  upsertMultipleQuestion: UpsertBulkQuestionsOutput;
  validateAccount: ValidateAccountOutput;
  validateOtp: Scalars['Boolean']['output'];
  validateSchoolProposal: Scalars['Boolean']['output'];
  validateStudentInvitation: Scalars['Boolean']['output'];
};


export type MutationActivateChatbotForLessonArgs = {
  enabled: Scalars['Boolean']['input'];
  lessonId: Scalars['MOID']['input'];
};


export type MutationAddGiftsToExamConfigArgs = {
  input: GiftsToExamConfigInput;
};


export type MutationAskToLessonArgs = {
  input: AskToLessonInput;
};


export type MutationCancelGenerateSectionArgs = {
  input: CancelSectionGenerationInput;
};


export type MutationCheckAccessCodeArgs = {
  input: ClassResourcesStudentValidation;
};


export type MutationCreateAclAssetArgs = {
  input: Array<AclAssetInput>;
};


export type MutationCreateAnnouncementArgs = {
  input: AnnoucementsInput;
};


export type MutationCreateAssetConfigArgs = {
  input: AssetConfigInput;
};


export type MutationCreateBacArgs = {
  input: BacInput;
};


export type MutationCreateBadgeArgs = {
  input: CreateBadgeInput;
};


export type MutationCreateCampaignArgs = {
  input: CampaignsInput;
};


export type MutationCreateCategoryArgs = {
  input: CategoryInput;
};


export type MutationCreateChapterArgs = {
  input: ChapterInput;
};


export type MutationCreateChapterQuestionArgs = {
  input: ChapterQuestionInput;
};


export type MutationCreateChariowClassMappingArgs = {
  input: CreateChariowClassMappingInput;
};


export type MutationCreateClassArgs = {
  input: ClassInput;
};


export type MutationCreateClassSchoolArgs = {
  input: ClassSchoolInput;
};


export type MutationCreateClassTeacherArgs = {
  input: ClassTeacherInput;
};


export type MutationCreateCompanyArgs = {
  input: CompanyInput;
};


export type MutationCreateConfigurationArgs = {
  input: CreateConfigurationInput;
};


export type MutationCreateConsumedCreditArgs = {
  input: ConsumedCreditInput;
};


export type MutationCreateCountryArgs = {
  input: CreateCountryInput;
};


export type MutationCreateCouponArgs = {
  input: CouponIntput;
};


export type MutationCreateDisciplineArgs = {
  input: DisciplineInput;
};


export type MutationCreateExamArgs = {
  input: ExamInput;
};


export type MutationCreateExamConfigArgs = {
  input: ExamConfigInput;
};


export type MutationCreateExamGenerationConfigArgs = {
  input: ExamGenerationConfigInput;
};


export type MutationCreateExamSubmissionArgs = {
  input: ExamSubmissionInput;
};


export type MutationCreateExerciseArgs = {
  input: ExerciseInput;
};


export type MutationCreateFaqArgs = {
  input: FaqInput;
};


export type MutationCreateFaqCategoryArgs = {
  input: FaqCategoryInput;
};


export type MutationCreateFeedbackArgs = {
  input: FeedbackInput;
};


export type MutationCreateFlashcardArgs = {
  input: FlashcardInput;
};


export type MutationCreateGamificationArgs = {
  input: GamificationInput;
};


export type MutationCreateGiftArgs = {
  input: CreateGiftInput;
};


export type MutationCreateGiftRequestArgs = {
  createGiftRequestInput: CreateGiftRequestInput;
};


export type MutationCreateGlossaryArgs = {
  input: GlossaryInput;
};


export type MutationCreateHighlightArgs = {
  input: HighlightInput;
};


export type MutationCreateIaSubscriptionArgs = {
  input: IaSubscriptionInput;
};


export type MutationCreateLessonArgs = {
  input: LessonInput;
};


export type MutationCreateModuleArgs = {
  createModuleInput: CreateModuleInput;
};


export type MutationCreateMultipleQuestionArgs = {
  input: MultipleQuestionsInput;
};


export type MutationCreateMultipleQuestionsExamGenerationConfigArgs = {
  input: CreateMultipleQuestionsExamGenerationConfigInput;
};


export type MutationCreateNotificationArgs = {
  createNotificationInput: CreateNotificationInput;
};


export type MutationCreateObjectiveArgs = {
  input: ObjectiveInput;
};


export type MutationCreatePaymentArgs = {
  input: PaymentInput;
};


export type MutationCreateProgressionArgs = {
  input: ProgressionInput;
};


export type MutationCreateQuestionArgs = {
  input: QuestionInput;
};


export type MutationCreateRegionArgs = {
  input: RegionInput;
};


export type MutationCreateSchoolArgs = {
  input: CreateSchoolInput;
};


export type MutationCreateSectionArgs = {
  input: SectionInput;
};


export type MutationCreateSeriesArgs = {
  input: SerieInput;
};


export type MutationCreateSociumIntegrationArgs = {
  input: CreateSociumIntegrationInput;
};


export type MutationCreateSubscriptionPackageByClassArgs = {
  input: SubscriptionPackageByClassInput;
};


export type MutationCreateSubscriptionPackagesArgs = {
  input: CreateSubscriptionPackagesInput;
};


export type MutationCreateTeacherArgs = {
  input: TeacherInput;
};


export type MutationCreateTipArgs = {
  input: CreateTipsInput;
};


export type MutationCreateTipsCategoryArgs = {
  input: CreateTipsCategoryInput;
};


export type MutationCreateUserArgs = {
  input: UserInput;
};


export type MutationDeleteAclAssetArgs = {
  input: AclAssetInput;
};


export type MutationDeleteAdminSchoolFromSchoolArgs = {
  input: DeleteAdminSchoolFromSchoolInput;
};


export type MutationDeleteAdminsFromSchoolArgs = {
  input: DeleteAdminsFromSchoolInput;
};


export type MutationDeleteAnnouncementArgs = {
  id: Scalars['MOID']['input'];
};


export type MutationDeleteAssetConfigArgs = {
  id: Scalars['MOID']['input'];
};


export type MutationDeleteCampaignArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteChariowClassMappingArgs = {
  id: Scalars['MOID']['input'];
};


export type MutationDeleteCompanyArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteExamConfigArgs = {
  id: Scalars['MOID']['input'];
};


export type MutationDeleteExamGenerationConfigArgs = {
  id: Scalars['MOID']['input'];
};


export type MutationDeleteFaqArgs = {
  faq: Scalars['MOID']['input'];
};


export type MutationDeleteFaqCategoryArgs = {
  category: Scalars['MOID']['input'];
};


export type MutationDeleteGiftArgs = {
  id: Scalars['MOID']['input'];
};


export type MutationDeleteMultipleQuestionsForExamGenerationConfigArgs = {
  input: DeleteMultipleQuestionsExamGenerationConfigInput;
};


export type MutationDeleteTeacherFromSchoolArgs = {
  input: DeleteTeacherFromSchoolInput;
};


export type MutationDeleteTeachersFromSchoolArgs = {
  input: DeleteTeachersFromSchoolInput;
};


export type MutationDuplicateExamGenerationConfigArgs = {
  id: Scalars['MOID']['input'];
  input: DuplicateExamGenerationConfigInput;
};


export type MutationEndLiveSessionArgs = {
  sessionId: Scalars['MOID']['input'];
};


export type MutationEnsureClassLandingArgs = {
  classId: Scalars['MOID']['input'];
};


export type MutationEvaluateQuizzArgs = {
  input: EvaluateQuizzInput;
};


export type MutationFinalizeEvaluationArgs = {
  classId?: InputMaybe<Scalars['MOID']['input']>;
  correctAnswers: Scalars['Float']['input'];
  lessonId: Scalars['MOID']['input'];
  questions?: InputMaybe<Array<AttemptQuestionInput>>;
  score: Scalars['Float']['input'];
};


export type MutationForgotStudioPasswordArgs = {
  input: ForgotStudioPasswordInput;
};


export type MutationGenerateAudioArgs = {
  input: GenerateAudioInput;
};


export type MutationGenerateEvaluationArgs = {
  lessonId: Scalars['MOID']['input'];
};


export type MutationGenerateEvaluationQuestionsArgs = {
  input: GenerateEvaluationQuestionsInput;
};


export type MutationGenerateExamQuestionsArgs = {
  classId: Scalars['MOID']['input'];
  examGenerationConfigId: Scalars['MOID']['input'];
};


export type MutationGenerateExamTestArgs = {
  input: ExamTestInput;
};


export type MutationGenerateFlashcardsArgs = {
  input: GenerateFlashcardsInput;
};


export type MutationGenerateGlossariesArgs = {
  input: GenerateGlossariesInput;
};


export type MutationGenerateLiveSessionSummaryArgs = {
  sessionId: Scalars['MOID']['input'];
};


export type MutationGenerateModuleQuizzArgs = {
  classId?: InputMaybe<Scalars['MOID']['input']>;
  sectionId: Scalars['MOID']['input'];
};


export type MutationGenerateOtpArgs = {
  input: OtpInput;
};


export type MutationGeneratePaymentLinkArgs = {
  input: PaymentInput;
};


export type MutationGeneratePodcastArgs = {
  input: GeneratePodcastInput;
};


export type MutationGenerateSectionsArgs = {
  input: GenerateModuleInput;
};


export type MutationGenerateSummaryArgs = {
  input: GenerateSummaryInput;
};


export type MutationHandleJoinRequestArgs = {
  input: HandleJoinRequestInput;
};


export type MutationInitiateIaCreditCheckoutArgs = {
  input: InitiateIaCreditCheckoutInput;
};


export type MutationInitiatePublicClassCheckoutArgs = {
  input: InitiatePublicClassCheckoutInput;
};


export type MutationInviteAdminSchoolArgs = {
  input: AdminSchoolInvitationInput;
};


export type MutationInviteStudentToClassArgs = {
  input: ClassRessoucesInput;
};


export type MutationInviteTeacherArgs = {
  input: TeacherInvitationInput;
};


export type MutationJoinLiveSessionArgs = {
  classId: Scalars['MOID']['input'];
};


export type MutationJoinPublicClassArgs = {
  classId: Scalars['MOID']['input'];
};


export type MutationLaunchGenerateAudioByQueueArgs = {
  input: GenerateAudioInput;
};


export type MutationLaunchGenerateFlashcardsByQueueArgs = {
  input: GenerateFlashcardsInput;
};


export type MutationLaunchGenerateGlossariesByQueueArgs = {
  input: GenerateGlossariesInput;
};


export type MutationLaunchGeneratePodcastByQueueArgs = {
  input: GeneratePodcastInput;
};


export type MutationLaunchGenerateQuizzByQueueArgs = {
  input: QuizGenerateInput;
};


export type MutationLaunchGenerateSectionByQueueArgs = {
  input: GenerateModuleInput;
};


export type MutationLaunchGenerateSummaryByQueueArgs = {
  input: GenerateSummaryInput;
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationRemoveCategoryArgs = {
  id: Scalars['MOID']['input'];
};


export type MutationRemoveChapterArgs = {
  id: Scalars['MOID']['input'];
};


export type MutationRemoveClassArgs = {
  id: Scalars['MOID']['input'];
};


export type MutationRemoveConfigurationArgs = {
  key: ConfigurationKey;
};


export type MutationRemoveCountryArgs = {
  id: Scalars['MOID']['input'];
};


export type MutationRemoveDisciplineArgs = {
  id: Scalars['MOID']['input'];
};


export type MutationRemoveExamArgs = {
  id: Scalars['MOID']['input'];
};


export type MutationRemoveExerciseArgs = {
  id: Scalars['MOID']['input'];
};


export type MutationRemoveFlashcardArgs = {
  id: Scalars['MOID']['input'];
};


export type MutationRemoveGamificationArgs = {
  id: Scalars['MOID']['input'];
};


export type MutationRemoveGiftRequestArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveGlossaryArgs = {
  id: Scalars['MOID']['input'];
};


export type MutationRemoveHighlightArgs = {
  id: Scalars['MOID']['input'];
};


export type MutationRemoveLessonArgs = {
  id: Scalars['MOID']['input'];
};


export type MutationRemoveModuleArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveNotificationArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveObjectiveArgs = {
  id: Scalars['MOID']['input'];
};


export type MutationRemoveProgressionArgs = {
  id: Scalars['MOID']['input'];
};


export type MutationRemoveQuestionArgs = {
  id: Scalars['MOID']['input'];
};


export type MutationRemoveRegionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveSchoolArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveSectionArgs = {
  id: Scalars['MOID']['input'];
};


export type MutationRemoveSeriesArgs = {
  id: Scalars['MOID']['input'];
};


export type MutationRemoveStudentsFromClassArgs = {
  input: ClassRessoucesToDeleteInput;
};


export type MutationRemoveSubscriptionPackageArgs = {
  id: Scalars['MOID']['input'];
};


export type MutationRemoveTipArgs = {
  id: Scalars['MOID']['input'];
};


export type MutationRemoveTipsCategoryArgs = {
  id: Scalars['MOID']['input'];
};


export type MutationRequestToJoinClassArgs = {
  accessCode: Scalars['String']['input'];
};


export type MutationResendActivationLinkArgs = {
  input: ResendActivationLinkInput;
};


export type MutationResendJoinSchoolEmailArgs = {
  input: ResendJoinSchoolEmailInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationResetStudioPasswordArgs = {
  input: ResetStudioPasswordInput;
};


export type MutationRetrySectionsGenerationArgs = {
  input: RetrySectionsGenerationInput;
};


export type MutationRotateSociumIntegrationKeyArgs = {
  integrationId: Scalars['MOID']['input'];
};


export type MutationSaveGeneratedContentArgs = {
  input: GenerateContentInput;
};


export type MutationSaveSessionArgs = {
  input: SessionsInput;
};


export type MutationSaveTranscriptIdArgs = {
  sessionId: Scalars['MOID']['input'];
  transcriptId: Scalars['String']['input'];
};


export type MutationSeenAnnouncementByArgs = {
  input: SeenAnnoucementInput;
};


export type MutationSetFrontPageArgs = {
  id: Scalars['MOID']['input'];
};


export type MutationSetSchoolFeaturesArgs = {
  features: Scalars['GraphQLObject']['input'];
  schoolId: Scalars['MOID']['input'];
};


export type MutationSetSociumIntegrationStatusArgs = {
  input: SetSociumIntegrationStatusInput;
};


export type MutationStartLiveSessionArgs = {
  classId: Scalars['MOID']['input'];
};


export type MutationSubmitDissertationArgs = {
  input: DissertationInput;
};


export type MutationSubmitExamArgs = {
  input: ExamSubmissionInput;
};


export type MutationSubmitExamGenerationArgs = {
  input: ExamGenerationSubmissionInput;
};


export type MutationTeacherSchoolAdminLoginArgs = {
  input: EmailLoginInput;
};


export type MutationUnlinkGiftsFromExamConfigArgs = {
  input: UnlinkGiftsFromExamConfigInput;
};


export type MutationUpdateAnnouncementArgs = {
  id: Scalars['MOID']['input'];
  input: AnnoucementsInput;
};


export type MutationUpdateAssetConfigArgs = {
  id: Scalars['MOID']['input'];
  input: AssetConfigInput;
};


export type MutationUpdateCampaignArgs = {
  id: Scalars['String']['input'];
  input: CampaignsInputUpdate;
};


export type MutationUpdateCampaignStatArgs = {
  id: Scalars['MOID']['input'];
  input: CampaignsInputUpdateStat;
};


export type MutationUpdateCategoryArgs = {
  id: Scalars['MOID']['input'];
  input: CategoryInput;
};


export type MutationUpdateChapterArgs = {
  id: Scalars['MOID']['input'];
  input: ChapterInput;
};


export type MutationUpdateChariowClassMappingArgs = {
  id: Scalars['MOID']['input'];
  input: UpdateChariowClassMappingInput;
};


export type MutationUpdateClassArgs = {
  id: Scalars['MOID']['input'];
  input: ClassInput;
};


export type MutationUpdateClassLandingConfigurationArgs = {
  classId: Scalars['MOID']['input'];
  input: UpdateClassLandingConfigurationInput;
};


export type MutationUpdateClassLandingPresentationArgs = {
  classId: Scalars['MOID']['input'];
  landingPresentationMarkdown: Scalars['String']['input'];
};


export type MutationUpdateClassLandingSlugArgs = {
  classId: Scalars['MOID']['input'];
  slug: Scalars['String']['input'];
};


export type MutationUpdateClassSchoolArgs = {
  id: Scalars['MOID']['input'];
  input: ClassSchoolInput;
};


export type MutationUpdateClassTeacherArgs = {
  id: Scalars['MOID']['input'];
  input: ClassTeacherInput;
};


export type MutationUpdateConfigurationArgs = {
  input: UpdateConfigurationInput;
  key: ConfigurationKey;
};


export type MutationUpdateContentArgs = {
  contentId: Scalars['String']['input'];
  input: ContentUpdateInput;
  sectionId: Scalars['MOID']['input'];
};


export type MutationUpdateCountryArgs = {
  id: Scalars['MOID']['input'];
  input: CountryUpdateInput;
};


export type MutationUpdateCouponArgs = {
  id: Scalars['MOID']['input'];
  input: CouponUpdateInput;
};


export type MutationUpdateDisciplineArgs = {
  id: Scalars['MOID']['input'];
  input: UpdateDisciplineInput;
};


export type MutationUpdateExamArgs = {
  id: Scalars['MOID']['input'];
  input: ExamInput;
};


export type MutationUpdateExamConfigArgs = {
  id: Scalars['MOID']['input'];
  input: ExamConfigInput;
};


export type MutationUpdateExamGenerationConfigArgs = {
  id: Scalars['MOID']['input'];
  input: ExamGenerationConfigInput;
};


export type MutationUpdateExerciseArgs = {
  id: Scalars['MOID']['input'];
  input: ExerciseUpdateInput;
};


export type MutationUpdateFaqArgs = {
  faq: Scalars['MOID']['input'];
  input: FaqInput;
};


export type MutationUpdateFaqCategoryArgs = {
  category: Scalars['MOID']['input'];
  input: FaqCategoryInput;
};


export type MutationUpdateFlashcardArgs = {
  id: Scalars['MOID']['input'];
  input: FlashcardInput;
};


export type MutationUpdateGamificationArgs = {
  id: Scalars['MOID']['input'];
  input: GamificationInput;
};


export type MutationUpdateGiftArgs = {
  id: Scalars['MOID']['input'];
  input: UpdateGiftInput;
};


export type MutationUpdateGiftRequestArgs = {
  updateGiftRequestInput: UpdateGiftRequestInput;
};


export type MutationUpdateGlossaryArgs = {
  id: Scalars['MOID']['input'];
  input: GlossaryInput;
};


export type MutationUpdateHighlightArgs = {
  id: Scalars['MOID']['input'];
  input: HighLightUpdate;
};


export type MutationUpdateLessonArgs = {
  id: Scalars['MOID']['input'];
  input: LessonInputUpdate;
};


export type MutationUpdateModuleArgs = {
  updateModuleInput: UpdateModuleInput;
};


export type MutationUpdateModuleProgressionArgs = {
  input: ModuleProgressionInput;
  lessonId: Scalars['MOID']['input'];
};


export type MutationUpdateObjectiveArgs = {
  id: Scalars['MOID']['input'];
  input: ObjectiveInput;
};


export type MutationUpdatePasswordArgs = {
  input: UpdatePasswordInput;
};


export type MutationUpdateProgressionArgs = {
  input: ProgressionUpdateInput;
};


export type MutationUpdateQuestionArgs = {
  id: Scalars['MOID']['input'];
  input: QuestionInput;
};


export type MutationUpdateRegionArgs = {
  id: Scalars['ID']['input'];
  input: RegionInput;
};


export type MutationUpdateSchoolArgs = {
  id: Scalars['ID']['input'];
  input: CreateSchoolInput;
};


export type MutationUpdateSchoolStatusArgs = {
  id: Scalars['ID']['input'];
  status: SchoolStatus;
};


export type MutationUpdateSectionArgs = {
  id: Scalars['MOID']['input'];
  input: SectionUpdateInput;
};


export type MutationUpdateSeriesArgs = {
  id: Scalars['MOID']['input'];
  input: SerieInput;
};


export type MutationUpdateSociumIntegrationArgs = {
  input: UpdateSociumIntegrationInput;
};


export type MutationUpdateSubscriptionPackageArgs = {
  id: Scalars['MOID']['input'];
  input: UpdateSubscriptionPackagesInput;
};


export type MutationUpdateTeacherCreditByClassArgs = {
  input: UpdateSchoolTeacherCreditInput;
};


export type MutationUpdateTipArgs = {
  id: Scalars['MOID']['input'];
  input: UpdateTipsInput;
};


export type MutationUpdateTipsCategoryArgs = {
  id: Scalars['MOID']['input'];
  input: UpdateTipsCategoryInput;
};


export type MutationUpdateUserArgs = {
  input: UserInputUpdate;
};


export type MutationUpdateUserSchoolArgs = {
  input?: InputMaybe<UserUpdateSchool>;
  schoolId: Scalars['MOID']['input'];
};


export type MutationUpsertClassReminderCampaignArgs = {
  input: UpsertClassReminderCampaignInput;
};


export type MutationUpsertMultipleChaptersArgs = {
  input: Array<ChapterUpsertInput>;
};


export type MutationUpsertMultipleFlashcardsArgs = {
  input: Array<FlashcardUpsertInput>;
};


export type MutationUpsertMultipleGlossariesArgs = {
  input: Array<GlossaryUpsertInput>;
};


export type MutationUpsertMultipleQuestionArgs = {
  input: MultipleQuestionsInput;
};


export type MutationValidateAccountArgs = {
  input: ValidateAccountInput;
};


export type MutationValidateOtpArgs = {
  input: OtpValidationInput;
};


export type MutationValidateSchoolProposalArgs = {
  input: ValidateSchoolProposal;
};


export type MutationValidateStudentInvitationArgs = {
  input: ClassResourcesStudentValidation;
};

export type NewGiftInput = {
  /** name of gift */
  name: Scalars['String']['input'];
  /** ranking of gift */
  ranking: Scalars['String']['input'];
};

export type NotSeenAnnouncementQuery = {
  classId?: InputMaybe<Scalars['MOID']['input']>;
  disciplineId?: InputMaybe<Scalars['MOID']['input']>;
};

export type Notification = {
  __typename?: 'Notification';
  /** Example field (placeholder) */
  exampleField: Scalars['Int']['output'];
};

export type ObjectiveInput = {
  classes: Array<Scalars['MOID']['input']>;
  description: Scalars['String']['input'];
  series: Array<Scalars['MOID']['input']>;
};

export type ObjectiveOutput = {
  __typename?: 'ObjectiveOutput';
  _id: Scalars['MOID']['output'];
  classes: Array<ClassOutput>;
  description: Scalars['String']['output'];
  series: Array<SerieOutput>;
};

export type ObjectiveQuery = {
  class?: InputMaybe<Scalars['MOID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  serie?: InputMaybe<Scalars['MOID']['input']>;
};

export type OtpInput = {
  type?: OtpType;
  username: Scalars['String']['input'];
};

export enum OtpType {
  ForgotPassword = 'FORGOT_PASSWORD',
  OtpRegister = 'OTP_REGISTER'
}

export type OtpValidationInput = {
  otp: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type PackageInfos = {
  __typename?: 'PackageInfos';
  name: Scalars['String']['output'];
  packageId: Scalars['String']['output'];
  totalAmount: Scalars['String']['output'];
  totalAmountPending: Scalars['String']['output'];
  totalTransactions: Scalars['Float']['output'];
};

export type PaginatedClassOutput = {
  __typename?: 'PaginatedClassOutput';
  currentPage: Scalars['Int']['output'];
  data: Array<ClassOutput>;
  total: Scalars['Int']['output'];
};

export enum ParentRole {
  Parent = 'PARENT',
  Parrain = 'PARRAIN',
  Student = 'STUDENT',
  Teacher = 'TEACHER'
}

export type PaymentInput = {
  SubscriptionPackagesRef: Scalars['MOID']['input'];
  coupon_code?: InputMaybe<Scalars['String']['input']>;
  pspName?: InputMaybe<PaymentWay>;
};

export type PaymentOutput = {
  __typename?: 'PaymentOutput';
  _id: Scalars['MOID']['output'];
  checkout_link?: Maybe<Scalars['String']['output']>;
  coupon_code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  event?: Maybe<Scalars['String']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  need_redirection?: Maybe<Scalars['Boolean']['output']>;
  payment_duration: Scalars['Int']['output'];
  payment_method?: Maybe<Scalars['String']['output']>;
  price: Scalars['String']['output'];
  refCommand: Scalars['String']['output'];
  status: Scalars['String']['output'];
  subscription_packages_ref: SubscriptionPackagesOutput;
  user: UserOutput;
};

export enum PaymentStatus {
  Invalid = 'INVALID',
  Ok = 'OK',
  Pending = 'PENDING'
}

export enum PaymentWay {
  Card = 'CARD',
  FreeMoney = 'FREE_MONEY',
  MastercardCard = 'MASTERCARD_CARD',
  Maxit = 'MAXIT',
  OrangeMoney = 'ORANGE_MONEY',
  WaveMoney = 'WAVE_MONEY'
}

export type PaymentsPaginationOutput = {
  __typename?: 'PaymentsPaginationOutput';
  currentPage: Scalars['Int']['output'];
  data: Array<PaymentOutput>;
  total: Scalars['Int']['output'];
};

export type PaymentsQuery = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Limit is not required but has a default value */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Page is not required but has a default value */
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<PaymentStatus>;
  subscription_packages_ref?: InputMaybe<Array<Scalars['MOID']['input']>>;
  users?: InputMaybe<Array<Scalars['MOID']['input']>>;
};

export type PeriodFilterInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<PeriodType>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export enum PeriodType {
  All = 'ALL',
  Custom = 'CUSTOM',
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type PointsByClassSubjectInput = {
  /** Class for the points */
  classId: Scalars['MOID']['input'];
  /** Discipline for the points */
  disciplineId?: InputMaybe<Scalars['MOID']['input']>;
};

export type PremiumMetrics = {
  __typename?: 'PremiumMetrics';
  currentlyPremium: Scalars['Int']['output'];
  totalExPremium: Scalars['Int']['output'];
};

export type PreviewLinksOutput = {
  __typename?: 'PreviewLinksOutput';
  mobileUrl: Scalars['String']['output'];
  webUrl: Scalars['String']['output'];
};

export type Progression = {
  __typename?: 'Progression';
  classId?: Maybe<Scalars['MOID']['output']>;
  classInfo?: Maybe<ClassOutput>;
  /** Evaluation data for the lesson */
  evaluationData: Array<AttemptsOutput>;
  /** Soft delete flag */
  isDeleted: Scalars['Boolean']['output'];
  /** Last evaluation date */
  lastEvaluationDate?: Maybe<Scalars['DateTime']['output']>;
  /** Lesson for the progression */
  lesson: Scalars['MOID']['output'];
  /** Lesson for the progression */
  lessonObject: LessonOutput;
  /** Score of the lesson */
  lesson_score?: Maybe<Scalars['Int']['output']>;
  /** Module progression data */
  progressions: Array<ModuleProgressionOutput>;
  /** Status of the progression */
  status: ProgressionStatus;
  /** User emitting event */
  user: Scalars['MOID']['output'];
};

export type ProgressionByClass = {
  __typename?: 'ProgressionByClass';
  _id: Scalars['MOID']['output'];
  /** Evaluation data for the lesson */
  evaluationData: Array<ProgressionByClassAttempts>;
  /** Last evaluation date */
  lastEvaluationDate?: Maybe<Scalars['DateTime']['output']>;
  /** Lesson for the progression */
  lesson: LessonOutput;
  /** Score of the lesson */
  lesson_score?: Maybe<Scalars['Int']['output']>;
  /** Module progression data */
  progressions: Array<ProgressionByClassModule>;
  /** Status of the progression */
  status: ProgressionStatus;
  /** User emitting event */
  user: UserOutput;
};

export type ProgressionByClassAttempts = {
  __typename?: 'ProgressionByClassAttempts';
  /** Questions of the quizz */
  questions: Array<AttemptQuestionOutput>;
  /** Score of the quizz */
  score?: Maybe<Scalars['Int']['output']>;
};

export type ProgressionByClassModule = {
  __typename?: 'ProgressionByClassModule';
  /** Quizz data for the module */
  attempts: Array<ProgressionByClassAttempts>;
  /** Last evaluation date */
  lastEvaluationDate?: Maybe<Scalars['DateTime']['output']>;
  /** Score of the module */
  module_score?: Maybe<Scalars['Int']['output']>;
  /** Section for the module progression */
  section: SectionOutput;
  /** Status of the progression */
  status: ProgressionStatus;
};

export type ProgressionByClassPaginationOutput = {
  __typename?: 'ProgressionByClassPaginationOutput';
  currentPage: Scalars['Int']['output'];
  data: Array<ProgressionByClass>;
  stats: LessonProgressionByClassStatsOutput;
  total: Scalars['Int']['output'];
};

export type ProgressionByClassQuery = {
  /** Class for the progression */
  classId: Scalars['MOID']['input'];
  /** Discipline for the progression */
  lessonId: Scalars['MOID']['input'];
  /** User for the progression */
  studentId?: InputMaybe<Scalars['MOID']['input']>;
};

export type ProgressionByStudentQuery = {
  /** Class for the progression */
  classId: Scalars['MOID']['input'];
  /** Lesson for the progression */
  lessonId: Scalars['MOID']['input'];
  /** Student for the progression */
  studentId: Scalars['MOID']['input'];
};

export type ProgressionInput = {
  classId?: InputMaybe<Scalars['MOID']['input']>;
  /** Lesson for the progression */
  lesson: Scalars['MOID']['input'];
};

export type ProgressionOutput = {
  __typename?: 'ProgressionOutput';
  completedModules?: Maybe<Scalars['Int']['output']>;
  percentage?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ProgressionStatus>;
  totalModules?: Maybe<Scalars['Int']['output']>;
};

export enum ProgressionStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Started = 'STARTED'
}

export type ProgressionUpdateInput = {
  classId?: InputMaybe<Scalars['MOID']['input']>;
  /** Evaluation data for the lesson */
  evaluationData: Array<AttemptsInput>;
  /** Soft delete flag */
  isDeleted: Scalars['Boolean']['input'];
  /** Last evaluation date */
  lastEvaluationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Lesson for the progression */
  lesson: Scalars['MOID']['input'];
  /** Score of the lesson */
  lesson_score: Scalars['Int']['input'];
  /** Module progression data */
  progression: Array<ModuleProgressionInput>;
  /** Status of the progression */
  status: ProgressionStatus;
};

export enum PublicClassCheckoutStatus {
  Confirmed = 'CONFIRMED',
  Invalid = 'INVALID',
  Pending = 'PENDING'
}

export type PublicClassCheckoutStatusOutput = {
  __typename?: 'PublicClassCheckoutStatusOutput';
  className?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  status: PublicClassCheckoutStatus;
};

export type PublicClassLandingCardOutput = {
  __typename?: 'PublicClassLandingCardOutput';
  accentColor: Scalars['String']['output'];
  classId: Scalars['MOID']['output'];
  cover?: Maybe<Scalars['String']['output']>;
  lessonsCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  payToAccess: Scalars['Boolean']['output'];
  promoYear?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  studentsCount: Scalars['Int']['output'];
  subscriptionAccessMode?: Maybe<SubscriptionAccessMode>;
  subscriptionCurrency?: Maybe<Scalars['String']['output']>;
  subscriptionDurationDays?: Maybe<Scalars['Int']['output']>;
  subscriptionPricing?: Maybe<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
};

export type PublicClassLessonPreviewOutput = {
  __typename?: 'PublicClassLessonPreviewOutput';
  accentColor: Scalars['String']['output'];
  classId: Scalars['MOID']['output'];
  className: Scalars['String']['output'];
  cover?: Maybe<Scalars['String']['output']>;
  lesson: ClassLandingPreviewLessonOutput;
  module: PublicClassPreviewModuleOutput;
  payToAccess: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  subscriptionAccessMode?: Maybe<SubscriptionAccessMode>;
  subscriptionCurrency?: Maybe<Scalars['String']['output']>;
  subscriptionDurationDays?: Maybe<Scalars['Int']['output']>;
  subscriptionPricing?: Maybe<Scalars['String']['output']>;
};

export type PublicClassPreviewChapterOutput = {
  __typename?: 'PublicClassPreviewChapterOutput';
  content?: Maybe<PublicClassPreviewContentOutput>;
  id?: Maybe<Scalars['MOID']['output']>;
  mediaContent: Array<PublicClassPreviewMediaOutput>;
  name?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
};

export type PublicClassPreviewContentOutput = {
  __typename?: 'PublicClassPreviewContentOutput';
  html?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  markdown?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  type?: Maybe<SectionType>;
};

export type PublicClassPreviewMediaOutput = {
  __typename?: 'PublicClassPreviewMediaOutput';
  description?: Maybe<Scalars['String']['output']>;
  link: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  type: MediaType;
};

export type PublicClassPreviewModuleOutput = {
  __typename?: 'PublicClassPreviewModuleOutput';
  audio?: Maybe<Scalars['String']['output']>;
  chapters: Array<PublicClassPreviewChapterOutput>;
  content: Array<PublicClassPreviewContentOutput>;
  id: Scalars['MOID']['output'];
  mediaContent: Array<PublicClassPreviewMediaOutput>;
  position: Scalars['Int']['output'];
  stories: Array<PublicClassPreviewStoryOutput>;
  title: Scalars['String']['output'];
};

export type PublicClassPreviewStoryOutput = {
  __typename?: 'PublicClassPreviewStoryOutput';
  audio?: Maybe<Scalars['String']['output']>;
  audioScript?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  video?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  badgeProgress: BadgeProgress;
  badges: Array<BadgeOutput>;
  chapter: ChapterOutput;
  chapters: Array<ChapterOutput>;
  classReminderCampaign: ClassReminderCampaignOutput;
  classesByConfigNumbers: PaginatedClassOutput;
  examConfigs: Array<ExamConfigOutput>;
  examGenerationConfig: ExamGenerationConfig;
  examGenerationConfigs: Array<ExamGenerationConfig>;
  examGenerationDetails: Array<ExamGenerationSubmission>;
  examGenerationsForStudent: Array<ExamGenerationConfig>;
  examResult: ExamResultOutput;
  exercise: ExerciseOutput;
  exercises: Array<ExerciseOutput>;
  exercisesByLesson: Array<ExerciseOutput>;
  exercisesWithDisciplinesAndSeries: Array<ExerciseOutput>;
  findAclAssetsByAsset: Array<AclAsset>;
  findAllFaqCategories: Array<FaqCategory>;
  findAllFaqs: Array<Faq>;
  findConsumedCredits: ConsumedCreditsPagination;
  findDisciplinesByFilter: DisciplineOutput;
  findFaqByCategory: Array<Faq>;
  findFeedbacks: Array<FeedbackOutput>;
  flashcard: Flashcard;
  flashcards: Array<Flashcard>;
  generateQuizz: Array<QuestionOutput>;
  getAdminsBySchool: AdminBySchoolOutputPagination;
  getAllSchoolLessons: Array<LessonOutput>;
  getAllSchoolLessonsPaginated: LessonOutputPagination;
  getAllSubsciptionPackages: Array<SubscriptionPackagesOutput>;
  getAnnouncementById: AnnoucementOutput;
  getAnnouncementsByStudent: Array<AnnoucementOutput>;
  getAnnouncementsByTeacher: Array<AnnoucementOutput>;
  getBacs: Array<BacOutput>;
  getBlockedLessonsByStudent: Array<LessonOutput>;
  getCampaign: CampaignOutput;
  getCampaignDailyStats: CampaignStatDailyOutput;
  getCampaignStat: CampaignStatOutput;
  getCampaigns: CampaignsPaginationOutput;
  getCampaignsRunning: Array<CampaignOutput>;
  getCampaignsStats: CampaignsStatsOutput;
  getCategories: Array<CategoryOutput>;
  getCategory: CategoryOutput;
  getChariowClassMapping?: Maybe<ChariowClassMapping>;
  getChariowClassMappings: Array<ChariowClassMapping>;
  getClass: ClassOutput;
  getClassCountBySchool: ClassCountBySchoolOutput;
  getClassCountByTeacher: ClassCountByTeacherOutput;
  getClassIdByTag?: Maybe<Scalars['MOID']['output']>;
  getClassLanding: ClassLandingOutput;
  getClassRevenueDashboard: ClassRevenueDashboardOutput;
  getClassSubjectsByStudent: Array<GroupedLessonsOutput>;
  getClassSubjectsByStudentV2: Array<GroupedLessonsOutput>;
  getClasses: Array<ClassOutput>;
  getClassesByLesson: Array<ClassOutput>;
  getCompanies: Array<CompanyOutput>;
  getCompany: CompanyOutput;
  getConfiguration: Configuration;
  getConfigurations: Array<Configuration>;
  getConfigurationsByModule: Array<Configuration>;
  getContentById: ContentOutput;
  getCountries: Array<CountriesOutput>;
  getCountry: CountriesOutput;
  getCoupon: CouponOutput;
  getCoupons: Array<CouponOutput>;
  getCurrentLiveSession?: Maybe<LiveSessionOutput>;
  getCurrentUser: UserOutput;
  getDefaultDiscipline: DisciplineOutput;
  getDeferedLinkAbout: Scalars['String']['output'];
  getDiscipline: DisciplineOutput;
  getDisciplines: Array<DisciplineOutput>;
  getDisciplinesWithPagination: DisciplineOutputPagination;
  getEvaluationRemainingAttempts: RemainingAttemptsOutput;
  getExam: ExamOutput;
  getExamConfig: ExamConfigOutput;
  getExamCorrections?: Maybe<ExamSubmissionOutput>;
  getExamRanking: Array<ExamResultOutput>;
  getExams: Array<ExamFilteredOutput>;
  getExamsCount: Array<ExamCounterOutput>;
  getFinancialAnalytic: FinancialAnalyticOutput;
  getGamification: GamificationOutput;
  getGamificationHistories: Array<GamificationHistory>;
  getGamificationHistory: GamificationHistory;
  getGamifications: Array<GamificationOutput>;
  getGift: GiftOutput;
  getGifts: Array<GiftOutput>;
  getHighlightById: HighlightOutput;
  getHighlightBySlug: HighlightOutput;
  getHighlights: Array<HighlightOutput>;
  getLesson: LessonOutput;
  getLessonProgression: Scalars['Float']['output'];
  getLessonProgressionByClass: Array<ProgressionByClass>;
  getLessonProgressionByClassPaginated: ProgressionByClassPaginationOutput;
  getLessonProgressionDetails?: Maybe<Progression>;
  getLessons: Array<GroupedLessonsOutput>;
  getLessonsByDiscipline: Array<GroupedLessonsOutput>;
  getLessonsForAdmin: Array<GroupedLessonsOutput>;
  getLessonsWithProgression: Array<GroupedLessonsOutput>;
  getLiveSessions: Array<LiveSessionOutput>;
  getModulesCompleted: Scalars['Float']['output'];
  getMyClasses: Array<ClassOutput>;
  getMyRankingInfo: UserRankingOutput;
  getMySchoolClasses: Array<ClassSchoolTeacherOutput>;
  getNextExamConfig?: Maybe<ExamConfigOutput>;
  getObjective: ObjectiveOutput;
  getObjectives: Array<ObjectiveOutput>;
  getPayment: PaymentOutput;
  getPointsByClassSubject: Scalars['Float']['output'];
  getPreviewLinks: PreviewLinksOutput;
  getProgression: Progression;
  getProgressions: Array<Progression>;
  getPublicClassCheckoutStatus: PublicClassCheckoutStatusOutput;
  getPublicClassLessonPreview: PublicClassLessonPreviewOutput;
  getPublicClasses: Array<ClassOutput>;
  getQuestion: QuestionOutput;
  getQuestions: QuestionOutputPagination;
  getRankingBySubject: Array<UserRankingBySubjectOutput>;
  getRecordingLink: MediaAccessLinkOutput;
  getRegion: RegionOutput;
  getRegions: Array<RegionOutput>;
  getRemainingAttempts: RemainingAttemptsOutput;
  getSchool: SchoolOutput;
  getSchoolClasses: Array<ClassOutput>;
  getSchoolProposals: Array<SchoolOutput>;
  getSchools: Array<SchoolOutput>;
  getSchoolsStats: SchoolsStatsOutput;
  getSchoolsWithUsers: Array<SchoolOutput>;
  getSection?: Maybe<SectionOutput>;
  getSections: Array<SectionOutput>;
  getSerie: SerieOutput;
  getSeries: Array<SerieOutput>;
  getStats: UserStatsOutput;
  getStudentDetailsByClass: GetStudentDetailByClassOutput;
  getStudentsByClass: Array<StudentByClassOutput>;
  getStudentsByClassPaginated: StudentByClassOutputPagination;
  getSubscriptionPackage: SubscriptionPackagesOutput;
  getSubscriptionPackageByAssetId: SubscriptionPackagesOutput;
  getSubscriptionPackagesByClass: Array<SubscriptionPackagesOutput>;
  getTeachersBySchool: TeacherBySchoolOutputPagination;
  getTip: TipOutput;
  getTips: Array<TipOutput>;
  getTipsByCategory: Array<TipOutput>;
  getTipsCategories: Array<TipsCategoryOutput>;
  getTipsCategory: TipsCategoryOutput;
  getTopRanking: TopAndCurrentUrOutput;
  getTransactionSummary: Array<PackageInfos>;
  getTransactions: PaymentsPaginationOutput;
  getTranscriptLink: MediaAccessLinkOutput;
  getUser: UserOutput;
  getUserBac: Scalars['DateTime']['output'];
  getUserDisciplines: Array<DisciplineOutput>;
  getUserRankingInfo: UserRankingOutput;
  getUserSections: Array<SectionOutput>;
  getUserSectionsV2: Array<SectionOutput>;
  getUserStatistics: UserStatisticsOutput;
  getUsers: UserOutputPagination;
  getVerifiedSchools: Array<SchoolOutput>;
  giftRequest: GiftRequest;
  giftRequests: Array<GiftRequest>;
  glossaries: Array<Glossary>;
  glossary: Glossary;
  hasAlreadyAccount: Scalars['Boolean']['output'];
  iaSubscriptionsList: Array<IaSubscriptions>;
  isSuccessExam: Scalars['Boolean']['output'];
  listPublicClassLandings: Array<PublicClassLandingCardOutput>;
  listSociumIntegrations: Array<SociumIntegrationOutput>;
  module: Module;
  modules: Array<Module>;
  myBadges: Array<BadgeWithUserStatus>;
  notSeenAnnouncementsCount: Scalars['Float']['output'];
  notification: Notification;
  notifications: Array<Notification>;
  publicConfigurations: Array<Configuration>;
  sociumDiagnostics: SociumDiagnosticOutput;
  sociumIntegrationStats: SociumIntegrationStatsOutput;
  subscriptionPackagesByAssetType: Array<SubscriptionPackagesOutput>;
};


export type QueryBadgeProgressArgs = {
  badge: Scalars['MOID']['input'];
};


export type QueryChapterArgs = {
  id: Scalars['MOID']['input'];
};


export type QueryChaptersArgs = {
  query: ChapterQueryInput;
};


export type QueryClassReminderCampaignArgs = {
  classId: Scalars['MOID']['input'];
};


export type QueryClassesByConfigNumbersArgs = {
  query: ClassByConfigNumbersQuery;
};


export type QueryExamGenerationConfigArgs = {
  id: Scalars['MOID']['input'];
};


export type QueryExamGenerationConfigsArgs = {
  query: ExamGenerationConfigQuery;
};


export type QueryExamGenerationDetailsArgs = {
  query: ExamGenerationSubmissionByStudentInput;
};


export type QueryExamGenerationsForStudentArgs = {
  classId: Scalars['MOID']['input'];
};


export type QueryExamResultArgs = {
  query: ExamResultQuery;
};


export type QueryExerciseArgs = {
  id: Scalars['MOID']['input'];
};


export type QueryExercisesByLessonArgs = {
  lessonId: Scalars['MOID']['input'];
};


export type QueryFindAclAssetsByAssetArgs = {
  query: AclAssetQuery;
};


export type QueryFindAllFaqsArgs = {
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFindConsumedCreditsArgs = {
  query: ConsumedCreditQuery;
};


export type QueryFindDisciplinesByFilterArgs = {
  query: DisciplineQueryInput;
};


export type QueryFindFaqByCategoryArgs = {
  category: Scalars['MOID']['input'];
};


export type QueryFindFeedbacksArgs = {
  query: FeedbackQuery;
};


export type QueryFlashcardArgs = {
  id: Scalars['MOID']['input'];
};


export type QueryFlashcardsArgs = {
  query: FlashcardQueryInput;
};


export type QueryGenerateQuizzArgs = {
  query: QuestionQuery;
};


export type QueryGetAdminsBySchoolArgs = {
  query: UserSchoolQuery;
};


export type QueryGetAllSchoolLessonsArgs = {
  query?: InputMaybe<LessonTeacherSchoolQuery>;
};


export type QueryGetAllSchoolLessonsPaginatedArgs = {
  query?: InputMaybe<LessonTeacherSchoolQuery>;
};


export type QueryGetAllSubsciptionPackagesArgs = {
  query: SubscriptionQuery;
};


export type QueryGetAnnouncementByIdArgs = {
  id: Scalars['MOID']['input'];
};


export type QueryGetAnnouncementsByStudentArgs = {
  query: AnnoucementQuery;
};


export type QueryGetAnnouncementsByTeacherArgs = {
  query: TeacherAnnoucementQuery;
};


export type QueryGetBlockedLessonsByStudentArgs = {
  query: BlockedLessonsByStudentQuery;
};


export type QueryGetCampaignArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetCampaignDailyStatsArgs = {
  id: Scalars['MOID']['input'];
};


export type QueryGetCampaignStatArgs = {
  id: Scalars['MOID']['input'];
};


export type QueryGetCampaignsArgs = {
  query: CampaignsQuery;
};


export type QueryGetCampaignsRunningArgs = {
  query: CampaignsQuery;
};


export type QueryGetCategoryArgs = {
  id: Scalars['MOID']['input'];
};


export type QueryGetChariowClassMappingArgs = {
  id: Scalars['MOID']['input'];
};


export type QueryGetChariowClassMappingsArgs = {
  filter?: InputMaybe<ChariowClassMappingFilterInput>;
};


export type QueryGetClassArgs = {
  id: Scalars['MOID']['input'];
};


export type QueryGetClassCountBySchoolArgs = {
  query: ClassCountBySchoolInput;
};


export type QueryGetClassCountByTeacherArgs = {
  query: ClassCountByTeacherQuery;
};


export type QueryGetClassIdByTagArgs = {
  tag: Scalars['String']['input'];
};


export type QueryGetClassLandingArgs = {
  slug: Scalars['String']['input'];
};


export type QueryGetClassRevenueDashboardArgs = {
  query: ClassRevenueDashboardQuery;
};


export type QueryGetClassSubjectsByStudentArgs = {
  query: ClassSubjectByStudent;
};


export type QueryGetClassSubjectsByStudentV2Args = {
  query: ClassSubjectByStudent;
};


export type QueryGetClassesArgs = {
  query: ClassQuery;
};


export type QueryGetClassesByLessonArgs = {
  lessonId: Scalars['MOID']['input'];
};


export type QueryGetCompaniesArgs = {
  query: CompanyQuery;
};


export type QueryGetCompanyArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetConfigurationArgs = {
  key: ConfigurationKey;
};


export type QueryGetConfigurationsByModuleArgs = {
  module: Scalars['String']['input'];
};


export type QueryGetContentByIdArgs = {
  classId?: InputMaybe<Scalars['MOID']['input']>;
  contentId: Scalars['String']['input'];
  sectionId: Scalars['MOID']['input'];
};


export type QueryGetCountryArgs = {
  id: Scalars['MOID']['input'];
};


export type QueryGetCouponArgs = {
  id: Scalars['MOID']['input'];
};


export type QueryGetCurrentLiveSessionArgs = {
  classId: Scalars['MOID']['input'];
};


export type QueryGetDeferedLinkAboutArgs = {
  query: LinkQueryInput;
};


export type QueryGetDisciplineArgs = {
  id: Scalars['MOID']['input'];
};


export type QueryGetDisciplinesWithPaginationArgs = {
  query: DisciplineQueryInput;
};


export type QueryGetEvaluationRemainingAttemptsArgs = {
  lessonId: Scalars['MOID']['input'];
};


export type QueryGetExamArgs = {
  id: Scalars['MOID']['input'];
};


export type QueryGetExamConfigArgs = {
  id: Scalars['MOID']['input'];
};


export type QueryGetExamCorrectionsArgs = {
  query: ExamSubmissionQuery;
};


export type QueryGetExamRankingArgs = {
  query: ExamResultQuery;
};


export type QueryGetExamsArgs = {
  query: ExamQuery;
};


export type QueryGetFinancialAnalyticArgs = {
  period?: InputMaybe<PeriodFilterInput>;
};


export type QueryGetGamificationArgs = {
  id: Scalars['MOID']['input'];
};


export type QueryGetGamificationHistoryArgs = {
  id: Scalars['MOID']['input'];
};


export type QueryGetGamificationsArgs = {
  query: GamificationQuery;
};


export type QueryGetGiftArgs = {
  id: Scalars['MOID']['input'];
};


export type QueryGetHighlightByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetHighlightBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryGetHighlightsArgs = {
  query: HighlightQuery;
};


export type QueryGetLessonArgs = {
  classId?: InputMaybe<Scalars['MOID']['input']>;
  id: Scalars['MOID']['input'];
};


export type QueryGetLessonProgressionArgs = {
  classId?: InputMaybe<Scalars['MOID']['input']>;
  lessonId: Scalars['MOID']['input'];
};


export type QueryGetLessonProgressionByClassArgs = {
  query: ProgressionByClassQuery;
};


export type QueryGetLessonProgressionByClassPaginatedArgs = {
  query: GetLessonProgressionByClassPaginatedInput;
};


export type QueryGetLessonProgressionDetailsArgs = {
  query: ProgressionByStudentQuery;
};


export type QueryGetLessonsArgs = {
  query: LessonQuery;
};


export type QueryGetLessonsByDisciplineArgs = {
  discipline: Scalars['MOID']['input'];
};


export type QueryGetLessonsForAdminArgs = {
  query?: InputMaybe<LessonAdminQuery>;
};


export type QueryGetLessonsWithProgressionArgs = {
  query: LessonQuery;
};


export type QueryGetLiveSessionsArgs = {
  classId: Scalars['MOID']['input'];
};


export type QueryGetMySchoolClassesArgs = {
  query: ClassSchoolTeacherQuery;
};


export type QueryGetObjectiveArgs = {
  id: Scalars['MOID']['input'];
};


export type QueryGetObjectivesArgs = {
  query: ObjectiveQuery;
};


export type QueryGetPaymentArgs = {
  id: Scalars['MOID']['input'];
};


export type QueryGetPointsByClassSubjectArgs = {
  query: PointsByClassSubjectInput;
};


export type QueryGetPreviewLinksArgs = {
  query: LinkQueryInput;
};


export type QueryGetProgressionArgs = {
  id: Scalars['MOID']['input'];
};


export type QueryGetPublicClassCheckoutStatusArgs = {
  token: Scalars['String']['input'];
};


export type QueryGetPublicClassLessonPreviewArgs = {
  slug: Scalars['String']['input'];
};


export type QueryGetPublicClassesArgs = {
  query: ClassQuery;
};


export type QueryGetQuestionArgs = {
  id: Scalars['MOID']['input'];
};


export type QueryGetQuestionsArgs = {
  query: QuestionQuery;
};


export type QueryGetRankingBySubjectArgs = {
  query: RankingBySubjectInput;
};


export type QueryGetRecordingLinkArgs = {
  sessionId: Scalars['MOID']['input'];
};


export type QueryGetRegionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetRemainingAttemptsArgs = {
  classId?: InputMaybe<Scalars['MOID']['input']>;
  sectionId: Scalars['MOID']['input'];
};


export type QueryGetSchoolArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSchoolClassesArgs = {
  query: SchoolClassQuery;
};


export type QueryGetSchoolProposalsArgs = {
  queries: SchoolProposalsQuery;
};


export type QueryGetSchoolsArgs = {
  query: SchoolQuery;
};


export type QueryGetSchoolsWithUsersArgs = {
  query: SchoolQuery;
};


export type QueryGetSectionArgs = {
  classId?: InputMaybe<Scalars['MOID']['input']>;
  contentType?: InputMaybe<SectionType>;
  id: Scalars['MOID']['input'];
};


export type QueryGetSectionsArgs = {
  classId?: InputMaybe<Scalars['MOID']['input']>;
  contentType?: InputMaybe<SectionType>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  lessonId: Scalars['MOID']['input'];
};


export type QueryGetSerieArgs = {
  id: Scalars['MOID']['input'];
};


export type QueryGetSeriesArgs = {
  query: SerieQuery;
};


export type QueryGetStatsArgs = {
  input: UserStatsQuery;
};


export type QueryGetStudentDetailsByClassArgs = {
  query: GetStudentDetailByClassInput;
};


export type QueryGetStudentsByClassArgs = {
  query: GetStudentsByClassInput;
};


export type QueryGetStudentsByClassPaginatedArgs = {
  query: GetStudentsByClassPaginatedInput;
};


export type QueryGetSubscriptionPackageArgs = {
  id: Scalars['MOID']['input'];
};


export type QueryGetSubscriptionPackageByAssetIdArgs = {
  assetId: Scalars['MOID']['input'];
};


export type QueryGetSubscriptionPackagesByClassArgs = {
  query: SubscriptionPackageByClass;
};


export type QueryGetTeachersBySchoolArgs = {
  query: UserSchoolQuery;
};


export type QueryGetTipArgs = {
  id: Scalars['MOID']['input'];
};


export type QueryGetTipsArgs = {
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetTipsByCategoryArgs = {
  category: Scalars['MOID']['input'];
};


export type QueryGetTipsCategoryArgs = {
  id: Scalars['MOID']['input'];
};


export type QueryGetTopRankingArgs = {
  query: UserRankingQuery;
};


export type QueryGetTransactionsArgs = {
  queries: PaymentsQuery;
};


export type QueryGetTranscriptLinkArgs = {
  sessionId: Scalars['MOID']['input'];
};


export type QueryGetUserArgs = {
  id: Scalars['MOID']['input'];
};


export type QueryGetUserRankingInfoArgs = {
  id: Scalars['MOID']['input'];
};


export type QueryGetUserSectionsArgs = {
  classId?: InputMaybe<Scalars['MOID']['input']>;
  contentType?: InputMaybe<SectionType>;
  lessonId: Scalars['MOID']['input'];
};


export type QueryGetUserSectionsV2Args = {
  classId?: InputMaybe<Scalars['MOID']['input']>;
  contentType?: InputMaybe<SectionType>;
  lessonId: Scalars['MOID']['input'];
};


export type QueryGetUserStatisticsArgs = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryGetUsersArgs = {
  queries: UserQuery;
};


export type QueryGetVerifiedSchoolsArgs = {
  query: SchoolQuery;
};


export type QueryGiftRequestArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGlossariesArgs = {
  query: GlossaryQueryInput;
};


export type QueryGlossaryArgs = {
  id: Scalars['MOID']['input'];
};


export type QueryHasAlreadyAccountArgs = {
  username: Scalars['String']['input'];
};


export type QueryIsSuccessExamArgs = {
  query: ExamResultQuery;
};


export type QueryModuleArgs = {
  id: Scalars['Int']['input'];
};


export type QueryNotSeenAnnouncementsCountArgs = {
  query: NotSeenAnnouncementQuery;
};


export type QueryNotificationArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySociumDiagnosticsArgs = {
  integrationId: Scalars['MOID']['input'];
  ref: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type QuerySociumIntegrationStatsArgs = {
  integrationId: Scalars['MOID']['input'];
};


export type QuerySubscriptionPackagesByAssetTypeArgs = {
  assetType: AssetType;
};

export type QuestionContentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  discipline?: InputMaybe<Scalars['MOID']['input']>;
  lesson?: InputMaybe<Scalars['MOID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  responses: Array<ResponseContentInput>;
  section?: InputMaybe<Scalars['MOID']['input']>;
  type: QuestionType;
};

export type QuestionInput = {
  _id?: InputMaybe<Scalars['MOID']['input']>;
  chapter?: InputMaybe<Scalars['MOID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discipline?: InputMaybe<Scalars['MOID']['input']>;
  exercise?: InputMaybe<Scalars['MOID']['input']>;
  explanations?: Array<MediaContentInput>;
  image?: InputMaybe<Scalars['String']['input']>;
  lesson?: InputMaybe<Scalars['MOID']['input']>;
  mediaContent?: Array<MediaContentInput>;
  name: Scalars['String']['input'];
  responses: Array<ResponseInput>;
  section?: InputMaybe<Scalars['MOID']['input']>;
  series?: InputMaybe<Array<Scalars['MOID']['input']>>;
  type: QuestionType;
};

export type QuestionOutput = {
  __typename?: 'QuestionOutput';
  _id: Scalars['MOID']['output'];
  chapter?: Maybe<ChapterOutput>;
  description?: Maybe<Scalars['String']['output']>;
  discipline?: Maybe<DisciplineOutput>;
  explanations: Array<MediaContentOutput>;
  image?: Maybe<Scalars['String']['output']>;
  lesson?: Maybe<LessonOutput>;
  mediaContent: Array<MediaContentOutput>;
  name?: Maybe<Scalars['String']['output']>;
  responses: Array<ResponseOutput>;
  section?: Maybe<SectionOutput>;
  series?: Maybe<Array<SerieOutput>>;
  type: QuestionType;
};

export type QuestionOutputPagination = {
  __typename?: 'QuestionOutputPagination';
  currentPage: Scalars['Int']['output'];
  data: Array<QuestionOutput>;
  total: Scalars['Int']['output'];
};

export type QuestionQuery = {
  discipline?: InputMaybe<Scalars['MOID']['input']>;
  lesson?: InputMaybe<Scalars['MOID']['input']>;
  /** Limit is not required but has a default value */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Page is not required but has a default value */
  page?: InputMaybe<Scalars['Int']['input']>;
  section?: InputMaybe<Scalars['MOID']['input']>;
  series?: InputMaybe<Array<Scalars['MOID']['input']>>;
  type?: InputMaybe<QuestionType>;
};

export enum QuestionType {
  Matching = 'MATCHING',
  MissingWords = 'MISSING_WORDS',
  Qcm = 'QCM',
  ShortResponse = 'SHORT_RESPONSE',
  TrueOrFalse = 'TRUE_OR_FALSE'
}

export type QuestionsModuleOutput = {
  __typename?: 'QuestionsModuleOutput';
  questions: Array<QuestionOutput>;
};

export type QuizGenerateInput = {
  chapterIds: Array<Scalars['MOID']['input']>;
  fillInTheBlankCount?: InputMaybe<Scalars['Float']['input']>;
  qcmCount?: InputMaybe<Scalars['Float']['input']>;
  schoolId?: InputMaybe<Scalars['MOID']['input']>;
  shortResponseCount?: InputMaybe<Scalars['Float']['input']>;
  trueFalseCount?: InputMaybe<Scalars['Float']['input']>;
};

export type RankingBySubjectInput = {
  /** Subject for the ranking */
  classId: Scalars['MOID']['input'];
  /** Discipline for the ranking */
  disciplineId: Scalars['MOID']['input'];
};

export type RegionInput = {
  name: Scalars['String']['input'];
};

export type RegionOutput = {
  __typename?: 'RegionOutput';
  _id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type RegionStat = {
  __typename?: 'RegionStat';
  clicks: Scalars['Float']['output'];
  region: Scalars['String']['output'];
  views: Scalars['Float']['output'];
};

export type RemainingAttemptsOutput = {
  __typename?: 'RemainingAttemptsOutput';
  isBlocked: Scalars['Boolean']['output'];
  remainingAttempts: Scalars['Int']['output'];
  remainingTimeInMinutes?: Maybe<Scalars['Int']['output']>;
};

export type ResendActivationLinkInput = {
  email: Scalars['String']['input'];
  school?: InputMaybe<Scalars['MOID']['input']>;
};

export type ResendJoinSchoolEmailInput = {
  email: Scalars['String']['input'];
  school: Scalars['MOID']['input'];
};

export type ResetPasswordInput = {
  password: Scalars['String']['input'];
  username: Scalars['PNSN']['input'];
};

export type ResetStudioPasswordInput = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type ResponseContentInput = {
  isRight: Scalars['Boolean']['input'];
  key: Scalars['String']['input'];
  response: Scalars['String']['input'];
};

export type ResponseInput = {
  isRight: Scalars['Boolean']['input'];
  key: Scalars['String']['input'];
  matchResponse?: InputMaybe<Scalars['String']['input']>;
  response: Scalars['String']['input'];
};

export type ResponseOutput = {
  __typename?: 'ResponseOutput';
  isRight: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  matchResponse?: Maybe<Scalars['String']['output']>;
  response: Scalars['String']['output'];
};

export type ResubscriptionDistributionPoint = {
  __typename?: 'ResubscriptionDistributionPoint';
  resubscriptionCount: Scalars['Int']['output'];
  studentCount: Scalars['Int']['output'];
};

export type ResubscriptionMetrics = {
  __typename?: 'ResubscriptionMetrics';
  distributionChart: Array<ResubscriptionDistributionPoint>;
  resubscriptionRate: Scalars['Float']['output'];
  totalPremiumUsers: Scalars['Int']['output'];
  usersWhoResubscribed: Scalars['Int']['output'];
};

export type RetrySectionsGenerationInput = {
  generateAssets?: Scalars['Boolean']['input'];
  lessonId: Scalars['MOID']['input'];
  schoolId?: InputMaybe<Scalars['MOID']['input']>;
  sectionIds: Array<Scalars['MOID']['input']>;
};

export type RevenueTrendPoint = {
  __typename?: 'RevenueTrendPoint';
  period: Scalars['String']['output'];
  revenue: Scalars['Float']['output'];
};

export enum Roles {
  Admin = 'ADMIN',
  Preview = 'PREVIEW',
  SchoolAdmin = 'SCHOOL_ADMIN',
  SchoolSuperAdmin = 'SCHOOL_SUPER_ADMIN',
  Student = 'STUDENT',
  Teacher = 'TEACHER'
}

export type SalesDistribution = {
  __typename?: 'SalesDistribution';
  daily: Scalars['Int']['output'];
  monthly: Scalars['Int']['output'];
  quarterly: Scalars['Int']['output'];
  weekly: Scalars['Int']['output'];
};

export enum SchoolCategory {
  Professional = 'PROFESSIONAL',
  Secondary = 'SECONDARY',
  University = 'UNIVERSITY'
}

export type SchoolClassQuery = {
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  promoYear?: InputMaybe<Scalars['String']['input']>;
  school?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  serie?: InputMaybe<Scalars['String']['input']>;
};

export type SchoolContactInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type SchoolContactOutput = {
  __typename?: 'SchoolContactOutput';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phone: Scalars['String']['output'];
};

export enum SchoolLevel {
  High = 'HIGH',
  Middle = 'MIDDLE',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
  University = 'UNIVERSITY',
  Whole = 'WHOLE'
}

export type SchoolOutput = {
  __typename?: 'SchoolOutput';
  _id: Scalars['MOID']['output'];
  address?: Maybe<Scalars['String']['output']>;
  categories?: Maybe<Array<SchoolCategory>>;
  contact?: Maybe<SchoolContactOutput>;
  features?: Maybe<Scalars['GraphQLObject']['output']>;
  iaCredit?: Maybe<Scalars['Float']['output']>;
  level?: Maybe<SchoolLevel>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  region: RegionOutput;
  status?: Maybe<SchoolStatus>;
  totalStudents?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<SchoolType>;
};

export type SchoolProposalsQuery = {
  /** Limit is not required but has a default value */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Page is not required but has a default value */
  page?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['MOID']['input']>;
  type?: InputMaybe<SchoolType>;
};

export type SchoolQuery = {
  country?: InputMaybe<Scalars['MOID']['input']>;
  level?: InputMaybe<SchoolLevel>;
  /** Limit is not required but has a default value */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Page is not required but has a default value */
  page?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['MOID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SchoolStatus>;
  type?: InputMaybe<SchoolType>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SchoolStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum SchoolType {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type SchoolsStatsOutput = {
  __typename?: 'SchoolsStatsOutput';
  totalPending: Scalars['Float']['output'];
  totalPrivate: Scalars['Float']['output'];
  totalPublic: Scalars['Float']['output'];
  totalSchools: Scalars['Float']['output'];
};

export type ScoreByDisciplineOutput = {
  __typename?: 'ScoreByDisciplineOutput';
  discipline: DisciplineOutput;
  score: Scalars['Float']['output'];
};

export type SectionContent = {
  __typename?: 'SectionContent';
  html: Scalars['String']['output'];
  id: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  type: SectionType;
};

export type SectionContentInput = {
  html: Scalars['String']['input'];
  label: Scalars['String']['input'];
  text: Scalars['String']['input'];
  type: SectionType;
};

export type SectionGenerationHandlerOutput = {
  __typename?: 'SectionGenerationHandlerOutput';
  failedReason?: Maybe<Scalars['String']['output']>;
  status: SectionGenerationHandlerStatus;
  type: SectionGenerationHandlerType;
};

export enum SectionGenerationHandlerStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export enum SectionGenerationHandlerType {
  Content = 'CONTENT',
  Quizz = 'QUIZZ'
}

export type SectionInput = {
  audio?: InputMaybe<Scalars['String']['input']>;
  content: Array<SectionContentInput>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  lessonId: Scalars['MOID']['input'];
  mediaContent?: Array<MediaContentInput>;
  position?: Scalars['Float']['input'];
  stories?: InputMaybe<Array<StoryInput>>;
  title: Scalars['String']['input'];
};

export type SectionOutput = {
  __typename?: 'SectionOutput';
  _generatedChapters?: Maybe<Array<ChapterOutput>>;
  _generatedFlashcards?: Maybe<Array<Flashcard>>;
  _id: Scalars['MOID']['output'];
  audio?: Maybe<Scalars['String']['output']>;
  chapters?: Maybe<Array<ChapterOutput>>;
  content: Array<SectionContent>;
  flashcards?: Maybe<Array<Flashcard>>;
  generationHandler?: Maybe<Array<SectionGenerationHandlerOutput>>;
  generationObjectHandler?: Maybe<Scalars['GraphQLObject']['output']>;
  hasChapters?: Maybe<Scalars['Boolean']['output']>;
  hasQuiz?: Maybe<Scalars['Boolean']['output']>;
  isPublished?: Maybe<Scalars['Boolean']['output']>;
  lastScore?: Maybe<Scalars['Float']['output']>;
  lessonsId: Scalars['String']['output'];
  maxPoint?: Maybe<Scalars['Float']['output']>;
  mediaContent: Array<MediaContentOutput>;
  objectives?: Maybe<Array<Scalars['String']['output']>>;
  position: Scalars['Float']['output'];
  status?: Maybe<ProgressionStatus>;
  stories?: Maybe<Array<Story>>;
  title: Scalars['String']['output'];
};

export enum SectionType {
  Definition = 'DEFINITION',
  Example = 'EXAMPLE',
  Exercise = 'EXERCISE',
  Explanation = 'EXPLANATION',
  Introduction = 'INTRODUCTION',
  Main = 'MAIN',
  Summary = 'SUMMARY'
}

export type SectionUpdateInput = {
  audio?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Array<SectionContentInput>>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  lessonId?: InputMaybe<Scalars['MOID']['input']>;
  mediaContent?: InputMaybe<Array<MediaContentInput>>;
  position?: InputMaybe<Scalars['Float']['input']>;
  stories?: InputMaybe<Array<StoryInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SeenAnnoucementInput = {
  annoucementId: Scalars['MOID']['input'];
};

export type SeenByOutput = {
  __typename?: 'SeenByOutput';
  seenAt: Scalars['DateTime']['output'];
  student: UserOutput;
};

export type SerieInput = {
  classes: Array<Scalars['MOID']['input']>;
  name: Scalars['String']['input'];
};

export type SerieOutput = {
  __typename?: 'SerieOutput';
  _id: Scalars['MOID']['output'];
  class: ClassOutput;
  name: Scalars['String']['output'];
};

export type SerieQuery = {
  classes?: InputMaybe<Array<Scalars['MOID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SessionOutput = {
  __typename?: 'SessionOutput';
  _id: Scalars['MOID']['output'];
  sessionDuration: Scalars['Float']['output'];
  sessionEnd?: Maybe<Scalars['DateTime']['output']>;
  sessionStart: Scalars['DateTime']['output'];
  user: UserOutput;
};

export type SessionsInput = {
  sessionEnd?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SetSociumIntegrationStatusInput = {
  integrationId: Scalars['MOID']['input'];
  status: SociumIntegrationStatus;
};

export type SociumDiagnosticLineOutput = {
  __typename?: 'SociumDiagnosticLineOutput';
  label: Scalars['String']['output'];
  level: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SociumDiagnosticOutput = {
  __typename?: 'SociumDiagnosticOutput';
  lines: Array<SociumDiagnosticLineOutput>;
  ref: Scalars['String']['output'];
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type SociumIntegrationOutput = {
  __typename?: 'SociumIntegrationOutput';
  _id: Scalars['MOID']['output'];
  allowedRedirectDomains?: Maybe<Array<Scalars['String']['output']>>;
  apiKeyPrefix?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  environment: Scalars['String']['output'];
  name: Scalars['String']['output'];
  school?: Maybe<SchoolOutput>;
  schoolId: Scalars['MOID']['output'];
  status: SociumIntegrationStatus;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SociumIntegrationStatsOutput = {
  __typename?: 'SociumIntegrationStatsOutput';
  formationsCount: Scalars['Float']['output'];
  integrationId: Scalars['MOID']['output'];
  learnersCount: Scalars['Float']['output'];
  modulesCount: Scalars['Float']['output'];
  sessionsCount: Scalars['Float']['output'];
  usersProvisioned: Scalars['Float']['output'];
};

/** Statut d'une intégration Socium */
export enum SociumIntegrationStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type SociumIntegrationWithKeyOutput = {
  __typename?: 'SociumIntegrationWithKeyOutput';
  apiKey: Scalars['String']['output'];
  integration: SociumIntegrationOutput;
};

export enum Source {
  Facebook = 'facebook',
  Instagram = 'instagram',
  Invitation = 'invitation',
  Linkeding = 'linkeding',
  Organic = 'organic',
  Qrcode = 'qrcode',
  Referral = 'referral',
  Snapchat = 'snapchat',
  Tiktok = 'tiktok',
  Twitter = 'twitter',
  Website = 'website',
  Whatsapp = 'whatsapp'
}

export enum StatsType {
  CandidateStatus = 'CANDIDATE_STATUS',
  Class = 'CLASS',
  Gender = 'GENDER',
  Region = 'REGION',
  Series = 'SERIES',
  Subscription = 'SUBSCRIPTION'
}

export type Story = {
  __typename?: 'Story';
  _id?: Maybe<Scalars['MOID']['output']>;
  audio?: Maybe<Scalars['String']['output']>;
  audioScript?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  video?: Maybe<Scalars['String']['output']>;
};

export type StoryInput = {
  audio?: InputMaybe<Scalars['String']['input']>;
  audioScript?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  video?: InputMaybe<Scalars['String']['input']>;
};

export type StudentByClassOutput = {
  __typename?: 'StudentByClassOutput';
  _id?: Maybe<Scalars['MOID']['output']>;
  blockedAtSomeLessons?: Maybe<Scalars['Boolean']['output']>;
  completedLessons: Scalars['Int']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Gender>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  points: Scalars['Int']['output'];
  status?: Maybe<ClassRessoucesStudentStatus>;
  totalLessons: Scalars['Int']['output'];
};

export type StudentByClassOutputPagination = {
  __typename?: 'StudentByClassOutputPagination';
  currentPage: Scalars['Int']['output'];
  data: Array<StudentByClassOutput>;
  total: Scalars['Int']['output'];
};

export enum StudentSortBy {
  Points = 'POINTS'
}

export type SubPartOutput = {
  __typename?: 'SubPartOutput';
  commentaire?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['Float']['output']>;
  subPart: Scalars['String']['output'];
};

export enum SubscriptionAccessMode {
  Lifetime = 'LIFETIME',
  LimitedDays = 'LIMITED_DAYS'
}

export type SubscriptionPackageByClass = {
  classId: Scalars['MOID']['input'];
};

export type SubscriptionPackageByClassInput = {
  assetId: Scalars['MOID']['input'];
  assetType: AssetType;
  countries?: Array<Scalars['String']['input']>;
  currency: Currency;
  description: Scalars['String']['input'];
  duration?: InputMaybe<Scalars['Int']['input']>;
  isLifetime?: InputMaybe<Scalars['Boolean']['input']>;
  isTaxable?: Scalars['Boolean']['input'];
  pricing: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type SubscriptionPackagesOutput = {
  __typename?: 'SubscriptionPackagesOutput';
  _id: Scalars['MOID']['output'];
  assetId?: Maybe<Scalars['MOID']['output']>;
  assetObject?: Maybe<AssetObjectUnion>;
  assetType?: Maybe<AssetType>;
  countries: Array<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  description: Scalars['String']['output'];
  duration: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isImmutable?: Maybe<Scalars['Boolean']['output']>;
  isTaxable?: Maybe<Scalars['Boolean']['output']>;
  pricing: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: UserPayment;
};

export type SubscriptionQuery = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SubscriptionRevenues = {
  __typename?: 'SubscriptionRevenues';
  daily: Scalars['Float']['output'];
  monthly: Scalars['Float']['output'];
  quarterly: Scalars['Float']['output'];
  weekly: Scalars['Float']['output'];
  yearly: Scalars['Float']['output'];
};

export type SummaryContentInput = {
  markdown?: InputMaybe<Scalars['String']['input']>;
  reasoning: Scalars['String']['input'];
  summary: Scalars['String']['input'];
};

export type SummaryContentOutput = {
  __typename?: 'SummaryContentOutput';
  markdown?: Maybe<Scalars['String']['output']>;
  reasoning: Scalars['String']['output'];
  summary: Scalars['String']['output'];
};

export enum TargetVoice {
  Adam = 'ADAM',
  Adina = 'ADINA',
  Amelia = 'AMELIA',
  Antoine = 'ANTOINE',
  Audrey = 'AUDREY',
  ClaraDupont = 'CLARA_DUPONT',
  Daniel = 'DANIEL',
  Guillaume = 'GUILLAUME',
  Martin = 'MARTIN',
  Nicolas = 'NICOLAS'
}

export type TeacherAnnoucementQuery = {
  classId: Scalars['MOID']['input'];
  disciplineIds?: InputMaybe<Array<Scalars['MOID']['input']>>;
};

export type TeacherByClassOutput = {
  __typename?: 'TeacherByClassOutput';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type TeacherBySchoolOutput = {
  __typename?: 'TeacherBySchoolOutput';
  _id?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  iaCredit: Scalars['Int']['output'];
  isEnabled: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  status: AdditionalSchoolStatus;
};

export type TeacherBySchoolOutputPagination = {
  __typename?: 'TeacherBySchoolOutputPagination';
  currentPage: Scalars['Int']['output'];
  data: Array<TeacherBySchoolOutput>;
  total: Scalars['Int']['output'];
};

export type TeacherDisciplineInput = {
  email: Scalars['String']['input'];
  iaCredit?: Scalars['Float']['input'];
};

export type TeacherInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['PNSN']['input']>;
};

export type TeacherInvitationInput = {
  email: Scalars['String']['input'];
  iaCredit?: InputMaybe<Scalars['Float']['input']>;
  school: Scalars['MOID']['input'];
};

export type TipOutput = {
  __typename?: 'TipOutput';
  _id: Scalars['MOID']['output'];
  audio?: Maybe<Scalars['String']['output']>;
  category: TipsCategoryOutput;
  content?: Maybe<ContentTipsType>;
  description: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isPublished: Scalars['Boolean']['output'];
  tips: Array<TipOutput>;
  title: Scalars['String']['output'];
  type: TipType;
};

export enum TipType {
  Audio = 'AUDIO',
  Text = 'TEXT'
}

export type TipsCategoryOutput = {
  __typename?: 'TipsCategoryOutput';
  _id: Scalars['MOID']['output'];
  description: Scalars['String']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type TokenOutput = {
  __typename?: 'TokenOutput';
  accessToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
};

export type TopAndCurrentUrOutput = {
  __typename?: 'TopAndCurrentUROutput';
  currentUserRanking?: Maybe<Scalars['Int']['output']>;
  topRanking?: Maybe<Array<TopRankingOutput>>;
};

export type TopRankingOutput = {
  __typename?: 'TopRankingOutput';
  _id: Scalars['MOID']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  points: Scalars['Int']['output'];
  region?: Maybe<RegionOutput>;
  status?: Maybe<UserPayment>;
};

export type UnlinkGiftsFromExamConfigInput = {
  /** exam config id */
  examConfigId: Scalars['MOID']['input'];
  /** gifts of exam config */
  gifts: Array<Scalars['MOID']['input']>;
};

export type UpdateChariowClassMappingInput = {
  classId?: InputMaybe<Scalars['MOID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  storeId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateClassLandingConfigurationInput = {
  accentColor?: InputMaybe<Scalars['String']['input']>;
  faq?: Array<ClassLandingFaqInput>;
  presentationMarkdown?: InputMaybe<Scalars['String']['input']>;
  previewLessonId?: InputMaybe<Scalars['MOID']['input']>;
  slug: Scalars['String']['input'];
};

export type UpdateConfigurationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDisciplineInput = {
  categories?: InputMaybe<Array<Scalars['MOID']['input']>>;
  coefs?: InputMaybe<Array<CoefInput>>;
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<DisciplineType>;
  types?: InputMaybe<Array<DisciplineType>>;
};

export type UpdateGiftInput = {
  /** Image of the gift */
  image?: InputMaybe<Scalars['String']['input']>;
  /** Is the gift private */
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of the gift */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Points of the gift */
  points?: InputMaybe<Scalars['Float']['input']>;
  /** Rank to get the gift */
  ranking?: InputMaybe<Scalars['String']['input']>;
  /** Status of the gift */
  status?: InputMaybe<GiftStatus>;
};

export type UpdateGiftRequestInput = {
  /** Example field (placeholder) */
  exampleField?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
};

export type UpdateModuleInput = {
  /** Example field (placeholder) */
  exampleField?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
};

export type UpdatePasswordInput = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};

export type UpdateSchoolTeacherCreditInput = {
  iaCredit: Scalars['Float']['input'];
  schoolId: Scalars['MOID']['input'];
  teacherEmail: Scalars['String']['input'];
};

export type UpdateSociumIntegrationInput = {
  allowedRedirectDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  integrationId: Scalars['MOID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSubscriptionPackagesInput = {
  assetId?: InputMaybe<Scalars['MOID']['input']>;
  assetType?: InputMaybe<AssetType>;
  concernBy?: InputMaybe<Array<ParentRole>>;
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  currency?: InputMaybe<Currency>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isLifetime?: InputMaybe<Scalars['Boolean']['input']>;
  isTaxable?: InputMaybe<Scalars['Boolean']['input']>;
  pricing?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<UserPayment>;
};

export type UpdateTipsCategoryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTipsInput = {
  audio?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['MOID']['input']>;
  content?: InputMaybe<ContentTipsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TipType>;
};

export type UpsertBulkQuestionsOutput = {
  __typename?: 'UpsertBulkQuestionsOutput';
  nameNotUpserted: Array<Scalars['String']['output']>;
  new: Scalars['Int']['output'];
  updated: Scalars['Int']['output'];
};

export type UpsertClassReminderCampaignInput = {
  classId: Scalars['MOID']['input'];
  isActive: Scalars['Boolean']['input'];
  sendHourLocal?: InputMaybe<Scalars['Int']['input']>;
  sendMinuteLocal?: InputMaybe<Scalars['Int']['input']>;
  templates?: InputMaybe<Array<ClassReminderTemplateInput>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  waveOffsetsDays?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UserDistribution = {
  __typename?: 'UserDistribution';
  freeCandidates: Scalars['Int']['output'];
  freeMode: Scalars['Int']['output'];
  freeTrialMode: Scalars['Int']['output'];
  premiumMode: Scalars['Int']['output'];
};

export type UserInput = {
  birthDate?: InputMaybe<Scalars['DateFormat']['input']>;
  class?: InputMaybe<Scalars['MOID']['input']>;
  country?: InputMaybe<Scalars['CountryCodeScalar']['input']>;
  disciplinesIssues?: InputMaybe<Array<Scalars['MOID']['input']>>;
  educatorType?: InputMaybe<EducatorType>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  freeCandidate?: InputMaybe<Scalars['Boolean']['input']>;
  gender: Gender;
  invitedBy?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  objectives?: Array<Scalars['MOID']['input']>;
  password: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['PNSN']['input']>;
  pushToken?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['MOID']['input']>;
  reminderTime?: InputMaybe<Scalars['String']['input']>;
  school?: InputMaybe<Scalars['MOID']['input']>;
  schoolProposal?: InputMaybe<Scalars['String']['input']>;
  schoolProposalType?: InputMaybe<SchoolType>;
  serie?: InputMaybe<Scalars['MOID']['input']>;
  sponsorshipSource?: InputMaybe<Source>;
};

export type UserInputUpdate = {
  birthDate?: InputMaybe<Scalars['DateFormat']['input']>;
  class?: InputMaybe<Scalars['MOID']['input']>;
  country?: InputMaybe<Scalars['CountryCodeScalar']['input']>;
  disciplinesIssues?: InputMaybe<Array<Scalars['MOID']['input']>>;
  educatorType?: InputMaybe<EducatorType>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  freeCandidate?: InputMaybe<Scalars['Boolean']['input']>;
  gender?: InputMaybe<Gender>;
  invitedBy?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  objectives?: InputMaybe<Array<Scalars['MOID']['input']>>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['PNSN']['input']>;
  pushToken?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['MOID']['input']>;
  reminderTime?: InputMaybe<Scalars['String']['input']>;
  school?: InputMaybe<Scalars['MOID']['input']>;
  schoolProposal?: InputMaybe<Scalars['String']['input']>;
  schoolProposalType?: InputMaybe<SchoolType>;
  serie?: InputMaybe<Scalars['MOID']['input']>;
  sponsorshipSource?: InputMaybe<Source>;
};

export type UserOutput = {
  __typename?: 'UserOutput';
  _id: Scalars['MOID']['output'];
  additionalSchools?: Maybe<Array<AdditionalSchoolOutput>>;
  archivedSchools?: Maybe<Array<AdditionalSchoolOutput>>;
  class?: Maybe<ClassOutput>;
  country?: Maybe<Scalars['String']['output']>;
  disciplinesIssues?: Maybe<Array<DisciplineOutput>>;
  educatorType?: Maybe<EducatorType>;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  freeCandidate?: Maybe<Scalars['Boolean']['output']>;
  gender?: Maybe<Gender>;
  invitedBy?: Maybe<UserOutput>;
  isEnterprise?: Maybe<Scalars['Boolean']['output']>;
  lastName: Scalars['String']['output'];
  objectives?: Maybe<Array<ObjectiveOutput>>;
  otherClasses?: Maybe<Array<ClassOutput>>;
  personalCredits?: Maybe<Scalars['Int']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  points: Scalars['Int']['output'];
  pushToken?: Maybe<Scalars['String']['output']>;
  region?: Maybe<RegionOutput>;
  reminderTime?: Maybe<Scalars['String']['output']>;
  role: Roles;
  school?: Maybe<SchoolOutput>;
  schoolClasses?: Maybe<Array<ClassOutput>>;
  serie?: Maybe<SerieOutput>;
  sponsorshipSource?: Maybe<Source>;
  status?: Maybe<UserPayment>;
  subscriptionExpireAt?: Maybe<Scalars['DateTime']['output']>;
  subscriptionPackage?: Maybe<SubscriptionPackagesOutput>;
  totalReferrals: Scalars['Float']['output'];
};

export type UserOutputPagination = {
  __typename?: 'UserOutputPagination';
  currentPage: Scalars['Int']['output'];
  data: Array<UserOutput>;
  total: Scalars['Int']['output'];
};

export enum UserPayment {
  Asset = 'ASSET',
  Free = 'FREE',
  FreeTrial = 'FREE_TRIAL',
  ProDaily = 'PRO_DAILY',
  ProMonth = 'PRO_MONTH',
  ProSemester = 'PRO_SEMESTER',
  ProTrimester = 'PRO_TRIMESTER',
  ProWeek = 'PRO_WEEK',
  ProYear = 'PRO_YEAR'
}

export type UserQuery = {
  classes?: InputMaybe<Array<Scalars['MOID']['input']>>;
  country?: InputMaybe<Scalars['String']['input']>;
  freeCandidate?: InputMaybe<Scalars['Boolean']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  /** Limit is not required but has a default value */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Page is not required but has a default value */
  page?: InputMaybe<Scalars['Int']['input']>;
  phoneNumbers?: InputMaybe<Array<Scalars['PNSN']['input']>>;
  regions?: InputMaybe<Array<Scalars['MOID']['input']>>;
  schools?: InputMaybe<Array<Scalars['MOID']['input']>>;
  series?: InputMaybe<Array<Scalars['MOID']['input']>>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UserRankingBySubjectOutput = {
  __typename?: 'UserRankingBySubjectOutput';
  email?: Maybe<Scalars['String']['output']>;
  /** First name */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Gender */
  gender?: Maybe<Scalars['String']['output']>;
  /** Last name */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Phone number */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Points */
  points: Scalars['Int']['output'];
};

export type UserRankingOutput = {
  __typename?: 'UserRankingOutput';
  _id: Scalars['MOID']['output'];
  badges: Array<BadgeWithUserStatus>;
  freeCandidateRanking?: Maybe<Scalars['String']['output']>;
  globalRanking?: Maybe<Scalars['Int']['output']>;
  points: Scalars['Int']['output'];
  schoolRanking?: Maybe<Scalars['Int']['output']>;
};

export type UserRankingQuery = {
  currentUserRanking?: Scalars['Boolean']['input'];
  type?: InputMaybe<UserRankingType>;
};

export enum UserRankingType {
  FreeCandidate = 'FREE_CANDIDATE',
  Global = 'GLOBAL',
  School = 'SCHOOL'
}

export type UserSchoolQuery = {
  email?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Float']['input'];
  page?: Scalars['Float']['input'];
  school: Scalars['MOID']['input'];
};

export type UserStatisticsOutput = {
  __typename?: 'UserStatisticsOutput';
  femaleUsers?: Maybe<Scalars['Int']['output']>;
  maleUsers?: Maybe<Scalars['Int']['output']>;
  totalReferrals?: Maybe<Scalars['Int']['output']>;
  totalUsers: Scalars['Int']['output'];
  totalUsersDeleted: Scalars['Int']['output'];
};

export type UserStatisticsQuery = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserStatsOutput = {
  __typename?: 'UserStatsOutput';
  labels: Array<Scalars['String']['output']>;
  values: Array<Scalars['Int']['output']>;
};

export type UserStatsQuery = {
  statistics?: InputMaybe<UserStatisticsQuery>;
  type?: StatsType;
};

export type UserUpdateSchool = {
  school: CreateSchoolInput;
};

export type ValidateAccountInput = {
  password?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

export type ValidateAccountOutput = {
  __typename?: 'ValidateAccountOutput';
  token?: Maybe<TokenOutput>;
  user?: Maybe<UserOutput>;
  validate: Scalars['Boolean']['output'];
};

export type AttemptsInput = {
  /** Redis reference for the quizz */
  redisReference?: InputMaybe<Scalars['String']['input']>;
  /** Score of the quizz */
  score: Scalars['Int']['input'];
};

export type AttemptsOutput = {
  __typename?: 'attemptsOutput';
  /** Questions of the quizz */
  questions: Array<AttemptQuestionOutput>;
  /** Quizz reference */
  quizz?: Maybe<Scalars['MOID']['output']>;
  /** Redis reference for the quizz */
  redisReference?: Maybe<Scalars['String']['output']>;
  /** Score of the quizz */
  score?: Maybe<Scalars['Int']['output']>;
};

export enum CouponType {
  Fixed = 'FIXED',
  Percent = 'PERCENT'
}

export enum Currency {
  Xaf = 'XAF',
  Xof = 'XOF'
}

export type Definition = {
  html: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type DefinitionOutput = {
  __typename?: 'definitionOutput';
  html: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type ValidateSchoolProposal = {
  id: Scalars['MOID']['input'];
  isValidated: Scalars['Boolean']['input'];
};

export type GetClassStudentsMonitoringQueryVariables = Exact<{
  query: GetStudentsByClassInput;
}>;


export type GetClassStudentsMonitoringQuery = { __typename?: 'Query', getStudentsByClass: Array<{ __typename?: 'StudentByClassOutput', _id?: any | null, blockedAtSomeLessons?: boolean | null, completedLessons: number, email?: string | null, firstName?: string | null, gender?: Gender | null, lastName?: string | null, phoneNumber?: string | null, points: number, status?: ClassRessoucesStudentStatus | null, totalLessons: number }> };

export type GetClassStudentDetailsMonitoringQueryVariables = Exact<{
  query: GetStudentDetailByClassInput;
}>;


export type GetClassStudentDetailsMonitoringQuery = { __typename?: 'Query', getStudentDetailsByClass: { __typename?: 'GetStudentDetailByClassOutput', _id?: any | null, birthDate: string, classRanking: number, firstName: string, gender?: Gender | null, lastName: string, phoneNumber: string, points: number, subscriptionDate?: any | null, disciplines: Array<{ __typename?: 'GetStudentDetailsDisciplineByClass', completedLessons: number, points: number, ranking: number, totalLessons: number, discipline: { __typename?: 'DisciplineOutput', _id: any, name: string }, teacher?: { __typename?: 'TeacherByClassOutput', firstName?: string | null, lastName?: string | null, email?: string | null } | null }>, progressions: Array<{ __typename?: 'Progression', lastEvaluationDate?: any | null, lesson_score?: number | null, status: ProgressionStatus, lessonObject: { __typename?: 'LessonOutput', _id: any, name: string, discipline?: { __typename?: 'DisciplineOutput', name: string } | null } }> } };

export type ClassMonitoringFieldsFragment = { __typename?: 'ClassOutput', _id: any, name: string, accessCode?: string | null, promoYear?: string | null, letter: string, payToAccess?: boolean | null, studentsCount: number, teachersCount: number, lessonsCount: number, createdAt: any, tags: Array<string>, school?: { __typename?: 'SchoolOutput', _id: any, name: string, type?: SchoolType | null, status?: SchoolStatus | null } | null, serie?: { __typename?: 'SerieOutput', _id: any, name: string } | null, classRef?: { __typename?: 'ClassOutput', _id: any, name: string } | null, assetConfigs?: Array<{ __typename?: 'AssetConfig', _id?: any | null, assetType: AssetConfigType }> | null } & { ' $fragmentName'?: 'ClassMonitoringFieldsFragment' };

export type GetSchoolClassesMonitoringQueryVariables = Exact<{
  query: SchoolClassQuery;
}>;


export type GetSchoolClassesMonitoringQuery = { __typename?: 'Query', getSchoolClasses: Array<(
    { __typename?: 'ClassOutput' }
    & { ' $fragmentRefs'?: { 'ClassMonitoringFieldsFragment': ClassMonitoringFieldsFragment } }
  )> };

export type GetClassMonitoringQueryVariables = Exact<{
  id: Scalars['MOID']['input'];
}>;


export type GetClassMonitoringQuery = { __typename?: 'Query', getClass: (
    { __typename?: 'ClassOutput', disciplines?: Array<{ __typename?: 'ClassDisciplineOutput', status: ClassDisciplineStatus, lessonsCount?: number | null, teacher?: { __typename?: 'FilteredUserOutput', firstName?: string | null, lastName?: string | null, email: string } | null, discipline: { __typename?: 'DisciplineOutput', _id: any, name: string, type: DisciplineType } }> | null }
    & { ' $fragmentRefs'?: { 'ClassMonitoringFieldsFragment': ClassMonitoringFieldsFragment } }
  ) };

export const ClassMonitoringFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClassMonitoringFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClassOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"accessCode"}},{"kind":"Field","name":{"kind":"Name","value":"promoYear"}},{"kind":"Field","name":{"kind":"Name","value":"letter"}},{"kind":"Field","name":{"kind":"Name","value":"payToAccess"}},{"kind":"Field","name":{"kind":"Name","value":"studentsCount"}},{"kind":"Field","name":{"kind":"Name","value":"teachersCount"}},{"kind":"Field","name":{"kind":"Name","value":"lessonsCount"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serie"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"classRef"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"assetType"}}]}}]}}]} as unknown as DocumentNode<ClassMonitoringFieldsFragment, unknown>;
export const GetClassStudentsMonitoringDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetClassStudentsMonitoring"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetStudentsByClassInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getStudentsByClass"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"blockedAtSomeLessons"}},{"kind":"Field","name":{"kind":"Name","value":"completedLessons"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"points"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"totalLessons"}}]}}]}}]} as unknown as DocumentNode<GetClassStudentsMonitoringQuery, GetClassStudentsMonitoringQueryVariables>;
export const GetClassStudentDetailsMonitoringDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetClassStudentDetailsMonitoring"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetStudentDetailByClassInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getStudentDetailsByClass"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"birthDate"}},{"kind":"Field","name":{"kind":"Name","value":"classRanking"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"points"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionDate"}},{"kind":"Field","name":{"kind":"Name","value":"disciplines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completedLessons"}},{"kind":"Field","name":{"kind":"Name","value":"points"}},{"kind":"Field","name":{"kind":"Name","value":"ranking"}},{"kind":"Field","name":{"kind":"Name","value":"totalLessons"}},{"kind":"Field","name":{"kind":"Name","value":"discipline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teacher"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"progressions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastEvaluationDate"}},{"kind":"Field","name":{"kind":"Name","value":"lesson_score"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lessonObject"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"discipline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetClassStudentDetailsMonitoringQuery, GetClassStudentDetailsMonitoringQueryVariables>;
export const GetSchoolClassesMonitoringDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSchoolClassesMonitoring"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SchoolClassQuery"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSchoolClasses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClassMonitoringFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClassMonitoringFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClassOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"accessCode"}},{"kind":"Field","name":{"kind":"Name","value":"promoYear"}},{"kind":"Field","name":{"kind":"Name","value":"letter"}},{"kind":"Field","name":{"kind":"Name","value":"payToAccess"}},{"kind":"Field","name":{"kind":"Name","value":"studentsCount"}},{"kind":"Field","name":{"kind":"Name","value":"teachersCount"}},{"kind":"Field","name":{"kind":"Name","value":"lessonsCount"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serie"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"classRef"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"assetType"}}]}}]}}]} as unknown as DocumentNode<GetSchoolClassesMonitoringQuery, GetSchoolClassesMonitoringQueryVariables>;
export const GetClassMonitoringDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetClassMonitoring"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MOID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getClass"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClassMonitoringFields"}},{"kind":"Field","name":{"kind":"Name","value":"disciplines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lessonsCount"}},{"kind":"Field","name":{"kind":"Name","value":"teacher"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discipline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClassMonitoringFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClassOutput"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"accessCode"}},{"kind":"Field","name":{"kind":"Name","value":"promoYear"}},{"kind":"Field","name":{"kind":"Name","value":"letter"}},{"kind":"Field","name":{"kind":"Name","value":"payToAccess"}},{"kind":"Field","name":{"kind":"Name","value":"studentsCount"}},{"kind":"Field","name":{"kind":"Name","value":"teachersCount"}},{"kind":"Field","name":{"kind":"Name","value":"lessonsCount"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serie"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"classRef"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetConfigs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"}},{"kind":"Field","name":{"kind":"Name","value":"assetType"}}]}}]}}]} as unknown as DocumentNode<GetClassMonitoringQuery, GetClassMonitoringQueryVariables>;